// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:41:22.335Z
// Property: South Oaks (ID: 6737460151192628)
// Collections: 28 amenities, 11 floorplans (live), 45 photos, 66 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192628",
  "property_external_id": "4709040",
  "property_zillow_url": "https://www.zillow.com/b/south-oaks-apartments-little-rock-ar-5Xhwxx/",
  "property_apartments_url": "https://www.apartments.com/south-oaks-little-rock-ar/bxbg0j9",
  "property_google_business_url": "https://www.google.com/maps/place/South+Oaks+Apartments/data=!4m2!3m1!1s0x0:0x5fdd75fec54ce984?sa=X&ved=2ahUKEwisz7aGx7ySAxV_KbkGHQQtF_8Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321280927",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "south-oaks",
  "property_name": "South Oaks",
  "property_website_url": "https://www.southoaksapthome.com/",
  "property_domain": "https://www.southoaksapthome.com/",
  "property_address": "3401 Fair Park Blvd",
  "property_full_address": "3401 Fair Park Blvd, Little Rock, AR 72204",
  "property_address_1": "3401 Fair Park Blvd",
  "property_address_2": null,
  "property_address_city": "Little Rock",
  "property_address_state": "AR",
  "property_address_zip_full": "72204-8922",
  "property_address_zip": "72204",
  "property_address_country": "US",
  "property_address_county": "Pulaski County",
  "property_neighborhood_address": "Oak Forest",
  "property_address_latitude": "34.72156280000001",
  "property_address_longitude": "-92.33368279999999",
  "property_email": "southoaks@rreafresidential.com",
  "property_phone": "(501) 562-6257",
  "property_call_tracking_phone": "501-298-4566",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your perfect home at South Oaks in Little Rock, AR! Choose from spacious one or two-bedroom floor plans and enjoy premium amenities like a pool, fitness center, and pet play area. Find your new home today—browse our availability or schedule a tour of our vibrant community!",
  "property_long_description": "Welcome to South Oaks, the premier apartment community in Little Rock, AR, where comfort meets convenience. Discover a range of thoughtfully designed floor plans, including spacious one-bedroom and two-bedroom options, perfect for any lifestyle. Each apartment features modern amenities that make it easy to settle in and feel at home.\n\nAt South Oaks, you'll enjoy a suite of exceptional community amenities that enhance your living experience. Dive into relaxation at our inviting pool, or stay active at our fully-equipped fitness center. Our clubhouse serves as a gathering place for planned social activities, while our gameroom promises endless fun with friends. For our furry residents, we offer a dedicated pet play area and a convenient pet washing station.\n\nAdditional conveniences include 24-hour access, package service, on-site retail, and a professional maintenance team always ready to assist. Enjoy the fresh air on our breathtaking waterfront, savor a meal in the picnic area, or unwind in the serene courtyard and sundeck areas.\n\nSouth Oaks is perfectly situated along walking and biking trails, making it an ideal choice for outdoor enthusiasts. With features like a car wash area, Wi-Fi accessibility, and a friendly on-site property manager, we’ve catered to your every need.\n\nFind your new home today at South Oaks! Browse our availability or schedule a tour to visit our vibrant community and experience all that we have to offer firsthand. Your ideal apartment living experience awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
  "property_featured_image_media": {
    "alt_text": "Sparkling swimming pool with blue lounge chairs and a waterfall feature.",
    "public_id": "019d0784-1e80-74ac-820a-ef90c08df461",
    "storage_key": "property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "204",
  "property_year_built": "1986",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.17647058823529",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>Breed restrictions apply at this community. Please inquire with the office. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://southoaks.loftliving.com/login",
  "property_apply_now_url": "https://8451244.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-b911-773d-a3af-d0a55b56d6ff.webp",
  "property_primary_logo_media": {
    "alt_text": "South Oaks Apartments logo",
    "public_id": "019e1def-b911-773d-a3af-d0a55b56d6ff",
    "storage_key": "property/6737460151192628/019e1def-b911-773d-a3af-d0a55b56d6ff.webp",
    "width": 359,
    "height": 114
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-b93e-71bf-beab-35baab0f10b8.webp",
  "property_secondary_logo_media": {
    "alt_text": "South Oaks Apartments logo",
    "public_id": "019e1def-b93e-71bf-beab-35baab0f10b8",
    "storage_key": "property/6737460151192628/019e1def-b93e-71bf-beab-35baab0f10b8.webp",
    "width": 359,
    "height": 114
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-b93e-71bf-beab-35baab0f10b8.webp",
  "property_mono_white_logo_media": {
    "alt_text": "South Oaks Apartments logo",
    "public_id": "019e1def-b93e-71bf-beab-35baab0f10b8",
    "storage_key": "property/6737460151192628/019e1def-b93e-71bf-beab-35baab0f10b8.webp",
    "width": 359,
    "height": 114
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-c304-729c-a0e8-53316b6ca552.webp",
  "property_mono_black_logo_media": {
    "alt_text": "South Oaks Apartments logo",
    "public_id": "019e1def-c304-729c-a0e8-53316b6ca552",
    "storage_key": "property/6737460151192628/019e1def-c304-729c-a0e8-53316b6ca552.webp",
    "width": 359,
    "height": 114
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "540 - 850",
  "property_sqft_min": "540",
  "property_sqft_max": "850",
  "property_price_range": "925",
  "property_price_min": null,
  "property_price_max": "925",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/people/South-Oaks-Apartments/61554951843632/",
  "property_instagram_url": "https://www.instagram.com/south_oaks_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJL7Ilq_Gk0ocRhOlMxf513V8",
  "property_youtube_url": "https://www.youtube.com/watch?v=aprepmzixwM",
  "property_yelp_url": "https://www.yelp.com/biz/south-oaks-apartments-little-rock",
  "property_tiktok_url": "https://www.tiktok.com/@southoaksapthomes",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to South Oaks",
  "property_home_romance_title": "Experience the Joy of Living in Your Dream Home",
  "property_home_amenities_blurb": "<p>Welcome to your new home at pet-friendly South Oaks! Our appealing <a href=\"/floor-plans/\">apartment</a> community nestled in Little Rock, Arkansas exudes charm. Situated in the Oak Forest neighborhood across from the University of Arkansas at Little Rock, our location is ideal for all lifestyles. Various retail, dining, and entertainment options wait right outside your door. Call us today to walk into the allure of our fabulous community.</p>",
  "property_home_floorplans_blurb": "<p>Ideally located in Little Rock, AR, the neighborhood surrounding South Oaks has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Check out the neighborhood!</p>",
  "property_home_gallery_blurb": "Experience the vibrant lifestyle at South Oaks in Little Rock, AR, where modern comforts meet community charm. Choose from spacious one and two-bedroom floor plans, all with controlled access, a refreshing pool, and a fully equipped fitness center. Picture yourself enjoying our cozy clubhouse or taking advantage of on-site maintenance.",
  "property_home_neighborhood_blurb": "Discover South Oaks in Little Rock, AR, where you can choose from spacious one and two-bedroom floor plans. Explore our vibrant neighborhood filled with local favorites and nearby attractions. See what's around our community and embrace the perfect blend of comfort and convenience. Your new home awaits at South Oaks!",
  "property_home_reviews_blurb": "At South Oaks in Little Rock, AR, residents rave about the sense of community and safety, with one noting, \"I always felt safe.\" With newly renovated apartments, a sparkling pool, and a welcoming atmosphere, find your ideal home where convenience meets comfort. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>Ideally located in Little Rock, AR, the neighborhood surrounding South Oaks has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Check out the neighborhood!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Our <a href=\"/neighborhood/\">community</a> dedicates itself to providing a relaxing atmosphere where you can enjoy all life offers. Exercise your mind and body at the state-of-the-art fitness center, catch the daytime rays beside the shimmering swimming pool, or unwind at the clubhouse. We love your pets and have included a bark park where they can run and play. Schedule a personal tour today and discover what you’ve been missing at South Oaks in Little Rock, AR.</p>",
  "property_applynow_blurb": "Discover your ideal apartment at South Oaks in Little Rock, AR! Choose from our spacious one and two-bedroom floor plans, and enjoy community amenities like a refreshing pool, fitness center, and pet-friendly areas. Don’t wait—find your new home and lease online today! Visit our Apply Now page!",
  "property_contactus_blurb": "Discover your ideal home at South Oaks in Little Rock, AR! Choose from spacious one and two-bedroom floor plans designed for comfort and style. Explore our community and find the perfect fit for your lifestyle. Have questions? Contact our leasing team today to learn more about your new home!",
  "property_faqs_blurb": "Discover your ideal home at South Oaks in Little Rock, AR, featuring spacious one and two-bedroom floor plans. Have questions? Our FAQs page has you covered! Browse now to find answers about our vibrant community and see why our residents love living at South Oaks.",
  "property_floorplans_blurb": "<p>We present two spacious floor plans of one or two bedroom apartments for rent designed with your comfort and happiness in mind. Amongst the many <a href=\"/amenities/\">amenities</a> in each home are central air and heating and walk-in closets to make your life comfortable and worry-free. Creating your favorite meal or something special in your all-electric kitchen with a dishwasher is a breeze. You’re sure to find what you’ve been searching for at South Oaks.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your perfect home at South Oaks in Little Rock, AR! Choose from spacious one and two-bedroom floor plans, and enjoy luxurious amenities like a pool, fitness center, and clubhouse. Use our interactive community map to explore available apartments and pricing. Your ideal lifestyle awaits—begin your journey today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>Breed restrictions apply at this community. Please inquire with the office. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover the perfect apartment at South Oaks in Little Rock, AR! Choose from spacious one or two-bedroom floor plans designed for comfort and style. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy the benefits together! Explore all our options to find your ideal home.",
  "property_residentaccess_blurb": "Welcome to South Oaks in Little Rock, AR, where stylish living meets convenience. Explore our thoughtfully designed one and two-bedroom floor plans, perfect for your lifestyle. Enhance your experience by accessing the resident portal to pay rent, schedule maintenance, and manage your home effortlessly. Log in today!",
  "property_reviews_blurb": "At South Oaks Apartments in Little Rock, residents rave about the vibrant community and unmatched convenience. As one UALR student shared, \"Being walking distance from campus was very convenient.\" Enjoy the newly renovated apartments, improved amenities, and a welcoming atmosphere that makes you feel right at home. See what our residents have to say!",
  "property_created_at": "1752257253760",
  "property_scheduletour_blurb": "Discover your ideal living space at South Oaks in Little Rock, AR! Choose from our spacious one and two-bedroom floor plans designed for comfort and convenience. Schedule a tour today and see what our residents love most about their community. Your perfect home awaits—don’t miss out!",
  "property_thankyou_blurb": "Thank you for your interest in South Oaks, your ideal apartment community in Little Rock, AR! We offer spacious one and two-bedroom floor plans designed for your comfort. Stay tuned—our team will reach out shortly to assist you in finding your perfect home. Explore our options and discover your next chapter!",
  "property_virtualtours_blurb": "<p>At South Oaks, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. South Oaks",
  "property_seo_title_home": "South Oaks | Apartments in Little Rock, AR",
  "property_seo_description_home": "Discover your ideal living space at South Oaks in Little Rock, AR! Choose from stylish one and two-bedroom floor plans, surrounded by an array of exceptional amenities, including a refreshing pool, state-of-the-art fitness center, and vibrant clubhouse. Enjoy 24-hour access, pet-friendly features, and online services, all while embracing the great outdoors with walking and biking trails. With planned social activities and a serene waterfront setting, South Oaks is the perfect place to call home. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Little Rock, AR",
  "property_seo_description_floorplans": "Explore the ideal living space at South Oaks in Little Rock, AR! Discover our diverse floor plans with one and two-bedroom options tailored to your lifestyle. Browse our available apartment homes today and find your perfect floor plan in our welcoming community.",
  "property_seo_title_amenities": "Amenities | Little Rock, AR Apartments for Rent",
  "property_seo_description_amenities": "Discover the vibrant lifestyle at South Oaks in Little Rock, AR! Choose from spacious one and two-bedroom floor plans and enjoy an array of exceptional amenities, including a refreshing pool, state-of-the-art fitness center, serene waterfront views, and organized social activities. With on-site retail, a pet play area, and convenient online services, everything you need is right at your fingertips. Explore our community today and experience the perfect blend of comfort and convenience!",
  "property_seo_title_gallery": "Gallery | Apartments in Little Rock, AR",
  "property_seo_description_gallery": "Discover your dream home at South Oaks in Little Rock, AR! Explore our stunning photo gallery showcasing our one and two-bedroom floor plans, and envision life surrounded by top-notch amenities like a refreshing pool, fitness center, and vibrant clubhouse. Enjoy outdoor spaces with a sundeck, picnic area, and waterfront views, or unwind in the gameroom and lounge. With on-site retail, planned social activities, and a pet-friendly environment featuring a play area and washing station, you'll love coming home to South Oaks. Picture yourself living here!",
  "property_seo_title_virtualtours": "Virtual Tours | South Oaks Apartments",
  "property_seo_description_virtualtours": "Explore South Oaks in Little Rock, AR! Discover our diverse floor plans featuring stylish one and two-bedroom apartments. Take a virtual tour of our vibrant community today and find your perfect rental home. Don’t miss out—step inside and imagine your new life at South Oaks!",
  "property_seo_title_interactivemap": "Interactive Map | South Oaks Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at South Oaks in Little Rock, AR! Our community offers spacious one and two-bedroom apartments, complete with a range of exceptional amenities like a refreshing pool, modern fitness center, vibrant clubhouse, and pet-friendly features including a play area and washing station. Enjoy 24-hour access, online services, and planned social activities, all while surrounded by beautiful walking and biking trails. Explore our interactive community map to find available apartments, view pricing, and select your perfect new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Little Rock, AR",
  "property_seo_description_neighborhood": "Discover vibrant living at South Oaks in Little Rock, AR! Explore our one and two-bedroom floor plans and immerse yourself in our friendly neighborhood. From local favorites to nearby attractions, see what's around our community and enhance your lifestyle today!",
  "property_seo_title_contact": "Contact Us | South Oaks",
  "property_seo_description_contact": "Discover your perfect home at South Oaks in Little Rock, AR! Explore our thoughtfully designed one and two-bedroom apartment floor plans that cater to your lifestyle. Have questions? Contact our leasing team today for more information and let us help you find your ideal living space!",
  "property_seo_title_faqs": "FAQs | Apartments in Little Rock, AR",
  "property_seo_description_faqs": "Discover your perfect home at South Oaks in Little Rock, AR! Explore our one and two-bedroom floor plans and enjoy exceptional amenities like a sparkling pool, fitness center, clubhouse, and pet-friendly spaces including a dog washing station and play area. With 24-hour access, on-site management, Wi-Fi, and planned social activities, you’ll never run out of things to do. Have questions? Browse our FAQs page for all the answers about our community and lifestyle!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Little Rock, AR",
  "property_seo_description_reviews": "Discover the vibrant community at South Oaks in Little Rock, AR! Explore our spacious one and two-bedroom floor plans. Enjoy top-notch amenities like a refreshing pool, state-of-the-art fitness center, clubhouse, and pet-friendly features including a play area and washing station. With on-site retail, planned social activities, and beautiful walking trails, there’s always something to do. Visit our Resident Reviews page to see what our residents love most about living at South Oaks and join our welcoming community today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Little Rock, AR",
  "property_seo_description_applynow": "Discover your ideal living space at South Oaks in Little Rock, AR! Choose from spacious one and two-bedroom floor plans designed for comfort. Enjoy a wealth of amenities including a refreshing pool, state-of-the-art fitness center, vibrant clubhouse, and a peaceful pet play area. Our community features 24-hour access, on-site maintenance, and planned social activities to enrich your lifestyle. With walking and biking trails, a sundeck, and picturesque waterfront views, you'll love exploring your new home. Ready to make the move? Apply now and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | South Oaks",
  "property_seo_description_residentaccess": "\"Welcome to the Resident Access Login for South Oaks in Little Rock, AR! Manage your living experience seamlessly—pay rent, schedule maintenance, and access community updates all in one place. Log in now for effortless apartment living!\"",
  "property_seo_title_referafriend": "Refer A Friend | South Oaks",
  "property_seo_description_referafriend": "\"Invite your friends to experience the charm of South Oaks in Little Rock, AR! Great friends make great neighbors—refer a friend today and enjoy exclusive rewards and a close-knit community vibe. Join us at South Oaks, where friendship thrives!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | South Oaks",
  "property_seo_description_scheduletour": "Discover your dream home at South Oaks in Little Rock, AR! Schedule a tour today and experience our stunning apartments, top-notch amenities, and inviting community atmosphere. Don’t miss out on finding your perfect fit—book your visit now!",
  "property_seo_title_privacy": "Privacy Policy | South Oaks",
  "property_seo_description_privacy": "Discover your peace of mind at South Oaks in Little Rock, AR. Our comprehensive privacy policy ensures your information is safe and secure. Explore how we protect your privacy and what it means for you as a resident. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | South Oaks",
  "property_seo_description_accessibility": "\"Discover a welcoming community at South Oaks in Little Rock, AR, where we prioritize accessibility for all residents and visitors. Explore our commitment to digital inclusion and ensure everyone can enjoy a seamless online experience. Learn more about our accessibility initiatives today!\"",
  "property_seo_title_sitemap": "Sitemap | South Oaks",
  "property_seo_description_sitemap": "\"Discover the full range of amenities and offerings at South Oaks in Little Rock, AR! Explore our user-friendly sitemap to find your perfect apartment, community features, and more. Start your journey to luxurious living today!\"",
  "property_seo_title_thankyou": "Thank You | South Oaks",
  "property_seo_description_thankyou": "Thank you for your interest in South Oaks! We're excited to connect with you about your new home in Little Rock, AR. A team member will be in touch shortly to assist you with your apartment search and answer any questions you may have. Stay tuned for your next steps towards finding the perfect place to call home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Little Rock, AR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293617385",
  "amenities": [
    {
      "id": "custom_e5709327-37e1-4f13-89c3-790635198863",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Access to Public Transportation",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da3a7618-9937-443f-bc60-30b47c41fb20",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_063e6a16-7869-4ee5-bf17-55eb8ca9384b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_89555c10-159c-46be-88d5-2293bbc1b762",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Community Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_83cf4657-1887-467a-bcee-6073ab0d1634",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Shopping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_624ab4e2-a205-4581-8171-8a8b6a7afa2a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a2a335cc-d65c-44d3-8c8d-05d4328ab874",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Guest Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d1f99aa-40e3-47df-a9a5-c38c334392d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "High-speed Internet Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9af80a79-7cc9-4c0c-8fb4-6eafed86ac9a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b03e9610-8870-44d6-9051-f8e30c7f218d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "On-call Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4e80b6ed-5c20-44d5-b104-1b626b6f2e40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba0676a9-ea41-4f35-a9ab-56294340519e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Courtesy Patrol",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b5ba0f43-b0ee-4f86-943b-48ee119582a6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Nearby Parks ",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cbaf8378-75a8-40bb-8d49-f35c51f0d3b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eaaf840a-cd78-4629-a0a0-bb2a41f5a317",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Sparkling Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_838abd29-d8b5-43b9-82ba-c52f7acb95a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Wellness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5861e669-a25a-4b5a-bed9-f5d256d97eb2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_92abed37-dcbb-4ed8-84bd-92f00d3145df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeted Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8911e093-fde8-4fb4-82bd-b88037e67be9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Central Heating and Air Conidtioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_977d7d4e-ebcb-454e-815d-dff69e4c0737",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9f38616c-7316-45b4-8518-2a455b78f2d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c2891249-98ef-4d12-9edc-a607143ae7bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Intrusion Alarm",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7dd6974-20f6-4a39-b0e2-7c8e0580a213",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Full-Size Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_60de152f-ea25-4659-98b5-2ff070912ac8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Vertical Blinds",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_49d711f0-ab99-4a69-ad2e-e7f81e3aa08b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Walk‑in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f92f3f1f-93b1-4ba8-bb5d-4a8860b5bf66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "All-Electric Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_04108d68-70fb-4b66-8f6c-6e1a6f2d229e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Sleek Black & Stainless-Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_53aa62df-b64d-403c-b5d0-6b9351ef3c85",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "external_id": "false",
      "title": "Built-In Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_2c07d5a5-2d6c-4953-acbb-d102fc18d2cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019fb382-7266-770c-af3e-0fc4a7568883.webp",
      "image_media": {
        "alt_text": "Community pool with blue lounge chairs and a stone waterfall feature",
        "public_id": "019fb382-7266-770c-af3e-0fc4a7568883",
        "storage_key": "property/6737460151192628/019fb382-7266-770c-af3e-0fc4a7568883.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning community pool, featuring comfortable lounge chairs and a beautiful stone waterfall for a serene ambiance.",
      "link": "",
      "alt_text": "Community pool with blue lounge chairs and a stone waterfall feature",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2e920f4b-06c7-4664-a547-d60c24b12f64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019fb382-6d6b-7252-b4da-70ce10f1e22c.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with waterfall feature and lounge chairs.",
        "public_id": "019fb382-6d6b-7252-b4da-70ce10f1e22c",
        "storage_key": "property/6737460151192628/019fb382-6d6b-7252-b4da-70ce10f1e22c.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling swimming pool, complete with a cascading waterfall and ample lounge seating. Perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with waterfall feature and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c7306fd2-c5a1-4ae8-b9c7-b412f35ff09d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019fb382-6c6c-70de-bcd3-8f1b6fc4d5e0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black cabinets and granite countertops.",
        "public_id": "019fb382-6c6c-70de-bcd3-8f1b6fc4d5e0",
        "storage_key": "property/6737460151192628/019fb382-6c6c-70de-bcd3-8f1b6fc4d5e0.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "This apartment kitchen features sleek black cabinetry, granite countertops, stainless steel sink, and modern appliances.",
      "link": "",
      "alt_text": "Modern kitchen with black cabinets and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_389e6a00-ebd4-464b-bc38-2bc4fdcb14bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019fb382-701b-7308-a8a4-8ebd2a8eeb12.webp",
      "image_media": {
        "alt_text": "Living room with sofa, accent chairs, and ottoman, opening to a bedroom.",
        "public_id": "019fb382-701b-7308-a8a4-8ebd2a8eeb12",
        "storage_key": "property/6737460151192628/019fb382-701b-7308-a8a4-8ebd2a8eeb12.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed living room, featuring plush seating and elegant decor. This inviting space seamlessly transitions into a serene bedroom, offering a complete and comfortable home.",
      "link": "",
      "alt_text": "Living room with sofa, accent chairs, and ottoman, opening to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_da390a1d-2cc9-40b0-92a5-16df140742fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019fb382-6cbc-76c6-9a6f-45cd3ef32ef1.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed and a ceiling fan.",
        "public_id": "019fb382-6cbc-76c6-9a6f-45cd3ef32ef1",
        "storage_key": "property/6737460151192628/019fb382-6cbc-76c6-9a6f-45cd3ef32ef1.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush king-sized bed, comfortable seating, and a ceiling fan for year-round comfort.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c74758c9-f038-4052-8557-3ed9b7befd29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019fb382-6e17-715b-9e3e-352718194628.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a stone waterfall feature and blue lounge chairs.",
        "public_id": "019fb382-6e17-715b-9e3e-352718194628",
        "storage_key": "property/6737460151192628/019fb382-6e17-715b-9e3e-352718194628.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with a beautiful stone waterfall and comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with a stone waterfall feature and blue lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b07cfd25-e612-4e79-a3ca-e797f657e287",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019fb382-6dc7-7699-bc2f-e1fbd5e46353.webp",
      "image_media": {
        "alt_text": "Clubhouse living area with sofas, armchairs, fireplace, coffee table, and dining table.",
        "public_id": "019fb382-6dc7-7699-bc2f-e1fbd5e46353",
        "storage_key": "property/6737460151192628/019fb382-6dc7-7699-bc2f-e1fbd5e46353.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed clubhouse, featuring a cozy fireplace, comfortable seating areas, and a convenient dining space.",
      "link": "",
      "alt_text": "Clubhouse living area with sofas, armchairs, fireplace, coffee table, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a7017e95-36e2-460d-aeaa-88c3cd7a4be2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019fb382-6d8a-768e-b972-059498c00f5b.webp",
      "image_media": {
        "alt_text": "Living room and dining area with gray couch, decorative pillows, and blue chairs.",
        "public_id": "019fb382-6d8a-768e-b972-059498c00f5b",
        "storage_key": "property/6737460151192628/019fb382-6d8a-768e-b972-059498c00f5b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable gray couch, decorative pillows, and elegant blue seating. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with gray couch, decorative pillows, and blue chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cdb878af-f6fd-4faf-b64d-31a93bddc694",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-6129-74c8-a963-edbcaa091192.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, mirror, and a bed with navy blue and white bedding.",
        "public_id": "019e84b3-6129-74c8-a963-edbcaa091192",
        "storage_key": "property/6737460151192628/019e84b3-6129-74c8-a963-edbcaa091192.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a dresser with a large mirror, plush carpeting, and a comfortable bed with elegant bedding. The room offers ample natural light and a connecting living area view.",
      "link": "",
      "alt_text": "Bedroom with a dresser, mirror, and a bed with navy blue and white bedding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a1c588b2-c9c9-4f09-af5d-24555c42be22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-6694-7289-89f8-4a1bfca6b746.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, two furry ottomans, a blue armchair, and a large piece of abstract art.",
        "public_id": "019e84b3-6694-7289-89f8-4a1bfca6b746",
        "storage_key": "property/6737460151192628/019e84b3-6694-7289-89f8-4a1bfca6b746.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, plush ottomans, and an elegant armchair. Perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Living room with a sofa, two furry ottomans, a blue armchair, and a large piece of abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2bbf3904-a9eb-4db7-88d1-5e64c1741a83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-6872-752d-916c-c31f3faee6f5.webp",
      "image_media": {
        "alt_text": "Modern black kitchen with granite countertops and stainless steel sink.",
        "public_id": "019e84b3-6872-752d-916c-c31f3faee6f5",
        "storage_key": "property/6737460151192628/019e84b3-6872-752d-916c-c31f3faee6f5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Featuring sleek black cabinetry, granite countertops, and a double basin sink, this kitchen is both stylish and functional.",
      "link": "",
      "alt_text": "Modern black kitchen with granite countertops and stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_602d07a3-bda6-4a8e-a67a-2b0fdacb2425",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019fb382-6c4f-770e-a12c-dd06c5018b62.webp",
      "image_media": {
        "alt_text": "Bathroom with a tub, toilet, and vanity.",
        "public_id": "019fb382-6c4f-770e-a12c-dd06c5018b62",
        "storage_key": "property/6737460151192628/019fb382-6c4f-770e-a12c-dd06c5018b62.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed bathroom, featuring a spacious tub and shower combination, modern vanity, and ample storage.",
      "link": "",
      "alt_text": "Bathroom with a tub, toilet, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5ec9f447-715f-4fdd-b151-bb91e39a2530",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-5fb2-75c7-bf05-a2171a2204be.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, two ottomans, a rug, and a blue armchair.",
        "public_id": "019e84b3-5fb2-75c7-bf05-a2171a2204be",
        "storage_key": "property/6737460151192628/019e84b3-5fb2-75c7-bf05-a2171a2204be.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, stylish ottomans, and a plush rug, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, two ottomans, a rug, and a blue armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b22dbeff-aab8-4589-a0ed-954b52b8f617",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-6737-73a9-87b7-ed7d8a03e3e2.webp",
      "image_media": {
        "alt_text": "Bedroom with a blue upholstered bed and dark blue bedding, a ceiling fan, and a glimpse into the bathroom.",
        "public_id": "019e84b3-6737-73a9-87b7-ed7d8a03e3e2",
        "storage_key": "property/6737460151192628/019e84b3-6737-73a9-87b7-ed7d8a03e3e2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a plush blue bed, elegant bedding, and a ceiling fan. Enjoy access to a well-appointed bathroom.",
      "link": "",
      "alt_text": "Bedroom with a blue upholstered bed and dark blue bedding, a ceiling fan, and a glimpse into the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c1da68e-dff4-4e4d-8714-c02bc1bfdf4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-1510-709c-98f1-17b061d9431f.webp",
      "image_media": {
        "alt_text": "Outdoor dog park with a tunnel and agility ramp.",
        "public_id": "019e84b3-1510-709c-98f1-17b061d9431f",
        "storage_key": "property/6737460151192628/019e84b3-1510-709c-98f1-17b061d9431f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious outdoor dog park, complete with a fun tunnel and agility ramp for your furry friends to play and explore.",
      "link": "",
      "alt_text": "Outdoor dog park with a tunnel and agility ramp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ceca3f7-df73-4d28-bb50-41b57bc2899b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-65c0-71d0-bae0-bc2d6781842f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with waterfall feature and blue lounge chairs",
        "public_id": "019e84b3-65c0-71d0-bae0-bc2d6781842f",
        "storage_key": "property/6737460151192628/019e84b3-65c0-71d0-bae0-bc2d6781842f.webp",
        "width": 3072,
        "height": 1843
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with a relaxing waterfall and ample lounge chairs for sunbathing.",
      "link": "",
      "alt_text": "Resort-style swimming pool with waterfall feature and blue lounge chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b18e0f3a-dd71-4db6-8c11-7a3373626d7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-3011-741f-acac-ce8df854d55f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinetry, granite countertops, and stainless steel sink.",
        "public_id": "019e84b3-3011-741f-acac-ce8df854d55f",
        "storage_key": "property/6737460151192628/019e84b3-3011-741f-acac-ce8df854d55f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this well-appointed kitchen, featuring sleek dark cabinets, beautiful granite countertops, and a spacious stainless steel sink. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinetry, granite countertops, and stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_256865a9-2a03-451f-993e-0eb6cd580d2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-4fef-748c-b257-b00d0ccbd037.webp",
      "image_media": {
        "alt_text": "Living room and dining area with modern furniture and dark cabinetry in the kitchen.",
        "public_id": "019e84b3-4fef-748c-b257-b00d0ccbd037",
        "storage_key": "property/6737460151192628/019e84b3-4fef-748c-b257-b00d0ccbd037.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed apartment, featuring a spacious living area that flows into a modern kitchen and a dedicated dining space. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with modern furniture and dark cabinetry in the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a25bb29c-4f4f-4ec4-b266-9f40b8ac3f9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-64b7-7288-b1d4-71eb8bdff94a.webp",
      "image_media": {
        "alt_text": "Bathroom with a white tub, toilet, vanity, and mirror.",
        "public_id": "019e84b3-64b7-7288-b1d4-71eb8bdff94a",
        "storage_key": "property/6737460151192628/019e84b3-64b7-7288-b1d4-71eb8bdff94a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this clean and modern bathroom featuring a white tub and shower combination, a sleek vanity with a granite countertop, and a large mirror.",
      "link": "",
      "alt_text": "Bathroom with a white tub, toilet, vanity, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cd490b53-a552-4455-9819-a79dcf784eb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-511a-77ed-834d-0a0657642020.webp",
      "image_media": {
        "alt_text": "Outdoor picnic area with built-in grill and blue picnic table.",
        "public_id": "019e84b3-511a-77ed-834d-0a0657642020",
        "storage_key": "property/6737460151192628/019e84b3-511a-77ed-834d-0a0657642020.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and cooking with our community's outdoor grilling station and picnic area.",
      "link": "",
      "alt_text": "Outdoor picnic area with built-in grill and blue picnic table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f942fc92-71c7-4090-8ec1-24d699a7a7cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-4daf-731a-a099-e6d254c443f3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with blue lounge chairs and waterfalls.",
        "public_id": "019e84b3-4daf-731a-a099-e6d254c443f3",
        "storage_key": "property/6737460151192628/019e84b3-4daf-731a-a099-e6d254c443f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with soothing waterfalls and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Outdoor swimming pool with blue lounge chairs and waterfalls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c3df1754-7bb1-4926-8518-99f1000a4ad1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-7dab-77eb-8c48-14f27c3afe19.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and other cardio machines.",
        "public_id": "019e84b3-7dab-77eb-8c48-14f27c3afe19",
        "storage_key": "property/6737460151192628/019e84b3-7dab-77eb-8c48-14f27c3afe19.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with everything you need for a great workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and other cardio machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_98d8fe69-775c-4d86-8b47-b85530604702",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019fb382-6e92-7504-9bee-64d490ccd6d7.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers and dryers, seating area, and vending machines.",
        "public_id": "019fb382-6e92-7504-9bee-64d490ccd6d7",
        "storage_key": "property/6737460151192628/019fb382-6e92-7504-9bee-64d490ccd6d7.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with modern washers and dryers, offering a comfortable and efficient experience for residents.",
      "link": "",
      "alt_text": "Laundry room with multiple washers and dryers, seating area, and vending machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59f9953c-20ad-4d5d-b758-20ff7cb52f32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-7eb7-7265-aad9-5a7abc13238a.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers and dryers, laundry cart, and exit doors.",
        "public_id": "019e84b3-7eb7-7265-aad9-5a7abc13238a",
        "storage_key": "property/6737460151192628/019e84b3-7eb7-7265-aad9-5a7abc13238a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with numerous washers and dryers, making chores a breeze. Includes a handy laundry cart for transport.",
      "link": "",
      "alt_text": "Laundry room with multiple washers and dryers, laundry cart, and exit doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c5a1c9c2-7f55-4092-b411-42ca7c81acef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-7964-758c-94d0-bbf09be3005b.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic tables and lounge chairs.",
        "public_id": "019e84b3-7964-758c-94d0-bbf09be3005b",
        "storage_key": "property/6737460151192628/019e84b3-7964-758c-94d0-bbf09be3005b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining with our community's outdoor grilling station, complete with picnic tables and comfortable seating. Perfect for summer barbecues.",
      "link": "",
      "alt_text": "Outdoor grilling area with picnic tables and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da107520-5e67-47b1-8617-058126a6255f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-7a95-76fe-a40f-b367c705b5f2.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with fireplace in the community lounge.",
        "public_id": "019e84b3-7a95-76fe-a40f-b367c705b5f2",
        "storage_key": "property/6737460151192628/019e84b3-7a95-76fe-a40f-b367c705b5f2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting community lounge, featuring a cozy fireplace and ample seating for residents to gather and socialize.",
      "link": "",
      "alt_text": "Comfortable seating area with fireplace in the community lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_590fc634-c200-43c3-a57e-b703ab851162",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-78dd-7084-a171-947ff7a018d3.webp",
      "image_media": {
        "alt_text": "Spacious leasing office with seating and coffee station.",
        "public_id": "019e84b3-78dd-7084-a171-947ff7a018d3",
        "storage_key": "property/6737460151192628/019e84b3-78dd-7084-a171-947ff7a018d3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our leasing office, offering a comfortable space for consultations and refreshments. Experience our amenities firsthand.",
      "link": "",
      "alt_text": "Spacious leasing office with seating and coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9ff40ff6-5374-426c-ade0-c2d41ee1ad00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-79a0-73d4-a255-3cf508862dfe.webp",
      "image_media": {
        "alt_text": "Clubhouse common area with sofas, coffee table, dining table, kitchen, and fireplace.",
        "public_id": "019e84b3-79a0-73d4-a255-3cf508862dfe",
        "storage_key": "property/6737460151192628/019e84b3-79a0-73d4-a255-3cf508862dfe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in the spacious clubhouse common area, featuring a comfortable seating area with sofas and a coffee table, a large dining table, a full kitchen, and a cozy fireplace.",
      "link": "",
      "alt_text": "Clubhouse common area with sofas, coffee table, dining table, kitchen, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_93d1e50a-82be-420e-9102-4430e3c7eac0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-63d3-7640-82eb-16c4278756cc.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a waterfall feature.",
        "public_id": "019e84b3-63d3-7640-82eb-16c4278756cc",
        "storage_key": "property/6737460151192628/019e84b3-63d3-7640-82eb-16c4278756cc.webp",
        "width": 3072,
        "height": 1843
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with a relaxing waterfall feature. Lounge chairs are available for your comfort.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and a waterfall feature.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39e61be4-da1f-499e-88a2-871d39ca9f00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-5356-727c-8b4c-b21df9f90c75.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with neutral walls, blinds on window, and wood-look flooring.",
        "public_id": "019e84b3-5356-727c-8b4c-b21df9f90c75",
        "storage_key": "property/6737460151192628/019e84b3-5356-727c-8b4c-b21df9f90c75.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and bright empty apartment living area featuring large windows with blinds and durable wood-look flooring.",
      "link": "",
      "alt_text": "Empty apartment living room with neutral walls, blinds on window, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29a6db17-20df-4333-9461-79da87973d58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-519e-763f-bd9d-f220edeef5e7.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with parking lot and cars.",
        "public_id": "019e84b3-519e-763f-bd9d-f220edeef5e7",
        "storage_key": "property/6737460151192628/019e84b3-519e-763f-bd9d-f220edeef5e7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of an apartment building featuring brick and siding, with a parking lot in the foreground. Offers ample parking for residents.",
      "link": "",
      "alt_text": "Apartment building exterior with parking lot and cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_690c3aed-aa13-43ce-afeb-97b301bffc30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-4c09-76e7-8409-05f5afbcf54d.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving",
        "public_id": "019e84b3-4c09-76e7-8409-05f5afbcf54d",
        "storage_key": "property/6737460151192628/019e84b3-4c09-76e7-8409-05f5afbcf54d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample wire shelving, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_05643fa1-aa3d-4790-a5fb-fb948493056e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-499d-772c-9241-08ec8c61458d.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and window.",
        "public_id": "019e84b3-499d-772c-9241-08ec8c61458d",
        "storage_key": "property/6737460151192628/019e84b3-499d-772c-9241-08ec8c61458d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A neutral-toned bedroom featuring a ceiling fan, a white door, and a window with blinds.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6f939fb6-7d0a-4b25-8490-bd36e84b399a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-48b2-771e-b146-6bf4aa1b76fc.webp",
      "image_media": {
        "alt_text": "Living room and dining room with wood-look flooring and a glimpse of the kitchen.",
        "public_id": "019e84b3-48b2-771e-b146-6bf4aa1b76fc",
        "storage_key": "property/6737460151192628/019e84b3-48b2-771e-b146-6bf4aa1b76fc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with wood-look flooring, leading to a compact kitchen.",
      "link": "",
      "alt_text": "Living room and dining room with wood-look flooring and a glimpse of the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_52fb9222-b512-471c-a632-36e021ecfa45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-3542-724e-8248-346261955ed8.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with parking lot and cars.",
        "public_id": "019e84b3-3542-724e-8248-346261955ed8",
        "storage_key": "property/6737460151192628/019e84b3-3542-724e-8248-346261955ed8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the apartment building showcasing its architecture and available parking spaces.",
      "link": "",
      "alt_text": "Exterior view of apartment building with parking lot and cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d9ba683b-5bb1-4569-8a9a-5a42eea37ed8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-3166-75df-a200-4476abec1053.webp",
      "image_media": {
        "alt_text": "South Oaks Apartments monument sign with phone number and building exterior.",
        "public_id": "019e84b3-3166-75df-a200-4476abec1053",
        "storage_key": "property/6737460151192628/019e84b3-3166-75df-a200-4476abec1053.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to South Oaks Apartments, a beautiful community offering comfortable living. Call us at 501.562.6257 to learn more.",
      "link": "",
      "alt_text": "South Oaks Apartments monument sign with phone number and building exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4e87908d-8684-4a0e-9a35-4c63fa09a4ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-1c32-76da-9b98-7541b4c5db33.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with waterfalls and lounge chairs.",
        "public_id": "019e84b3-1c32-76da-9b98-7541b4c5db33",
        "storage_key": "property/6737460151192628/019e84b3-1c32-76da-9b98-7541b4c5db33.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, featuring cascading waterfalls and comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with waterfalls and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1139b4ba-0832-4c61-9d5f-141858ae30c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-2ded-7417-8b80-ab4121ba1308.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer and \"South Oaks\" sign.",
        "public_id": "019e84b3-2ded-7417-8b80-ab4121ba1308",
        "storage_key": "property/6737460151192628/019e84b3-2ded-7417-8b80-ab4121ba1308.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay connected in our community business center, featuring computers and a printer for your convenience.",
      "link": "",
      "alt_text": "Business center with computers, printer and \"South Oaks\" sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_daf592bc-cd62-43cc-8966-1b8f285dec99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-37f1-720f-92c6-bf21c1f0208f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a stone waterfall.",
        "public_id": "019e84b3-37f1-720f-92c6-bf21c1f0208f",
        "storage_key": "property/6737460151192628/019e84b3-37f1-720f-92c6-bf21c1f0208f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a beautiful stone waterfall feature. Enjoy a refreshing dip on a sunny day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a stone waterfall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_48b0ba67-c9e3-417c-ac1f-b2350f092230",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-192a-7540-9618-551c6ffbf189.webp",
      "image_media": {
        "alt_text": "Black electric stove with oven and overhead microwave",
        "public_id": "019e84b3-192a-7540-9618-551c6ffbf189",
        "storage_key": "property/6737460151192628/019e84b3-192a-7540-9618-551c6ffbf189.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern black electric stove and microwave combination, perfect for any home chef. Ample counter space for meal preparation.",
      "link": "",
      "alt_text": "Black electric stove with oven and overhead microwave",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_777fed6f-5892-40b6-96d7-253b4f7ad3ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-17a2-769a-a93f-c795e93b7eec.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and waterfalls",
        "public_id": "019e84b3-17a2-769a-a93f-c795e93b7eec",
        "storage_key": "property/6737460151192628/019e84b3-17a2-769a-a93f-c795e93b7eec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, featuring cascading waterfalls and comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and waterfalls",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_db7587db-3ffd-412c-af86-2340f0d8b9af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-1789-771a-85d1-afab6d4b6c95.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with waterfalls and blue lounge chairs.",
        "public_id": "019e84b3-1789-771a-85d1-afab6d4b6c95",
        "storage_key": "property/6737460151192628/019e84b3-1789-771a-85d1-afab6d4b6c95.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with soothing waterfalls and comfortable lounge chairs for ultimate relaxation. A perfect oasis for residents.",
      "link": "",
      "alt_text": "Outdoor swimming pool with waterfalls and blue lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3037be66-9cda-4a4c-98a6-218f74b89105",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-1606-77cf-9875-a840e2751aeb.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and lights.",
        "public_id": "019e84b3-1606-77cf-9875-a840e2751aeb",
        "storage_key": "property/6737460151192628/019e84b3-1606-77cf-9875-a840e2751aeb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A well-lit bathroom vanity featuring a modern sink, granite countertop, and ample lighting, with a door in the background.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d89c1e4-4a3d-49f5-9aad-a024244b260c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-1363-732b-ada9-88339e7fa523.webp",
      "image_media": {
        "alt_text": "Interior view of a dining area and kitchen entrance in an apartment.",
        "public_id": "019e84b3-1363-732b-ada9-88339e7fa523",
        "storage_key": "property/6737460151192628/019e84b3-1363-732b-ada9-88339e7fa523.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover your new home with this spacious apartment featuring a convenient kitchen entrance and a well-lit dining area, perfect for everyday living.",
      "link": "",
      "alt_text": "Interior view of a dining area and kitchen entrance in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d91a96a0-27aa-4030-8099-77e69f41fbab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e84b3-13f0-720f-b2c2-a21703c4207e.webp",
      "image_media": {
        "alt_text": "Interior of a bedroom with beige walls, carpeted floor, and a ceiling fan.",
        "public_id": "019e84b3-13f0-720f-b2c2-a21703c4207e",
        "storage_key": "property/6737460151192628/019e84b3-13f0-720f-b2c2-a21703c4207e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring carpeted flooring, neutral walls, and a convenient ceiling fan for climate control.",
      "link": "",
      "alt_text": "Interior of a bedroom with beige walls, carpeted floor, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0316dec5-bb38-443e-b1d7-b518ec350e04",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "U.S. Pizza Co. Fair Park",
      "poi_type": "Restaurants",
      "poi_address": "3307 Fair Park Blvd, Little Rock, AR 72204, USA",
      "poi_short_description": "Long-running pizzeria chain serving classic & creative pies, plus sandwiches, beer & wine.",
      "poi_long_description": "Long-running pizzeria chain serving classic & creative pies, plus sandwiches, beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-a57e-733a-aeda-855a542a35e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-a57e-733a-aeda-855a542a35e0",
        "storage_key": "property/6737460151192628/019e1df1-a57e-733a-aeda-855a542a35e0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8080647178225121003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-pizza-co-fair-park",
      "poi_latitude": "34.7220405",
      "poi_longitude": "-92.3342393",
      "poi_miles_from_property": "0.06",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-565-6580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7258-7379-af56-8e6a8e6b1d88",
        "storage_key": "property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhXSqpfGk0ocR6_Zepcs5JHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_67645b76-f200-494c-ad3a-26b863f6e016",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Ceci's Chicken & Waffles",
      "poi_type": "Restaurants",
      "poi_address": "3301 Fair Park Blvd, Little Rock, AR 72204, USA",
      "poi_short_description": "Caramel pecan, chicken and waffles, and other comfort foods are the draw at this casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-9f36-75d6-8c89-def38bbdf521.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-9f36-75d6-8c89-def38bbdf521",
        "storage_key": "property/6737460151192628/019e1df1-9f36-75d6-8c89-def38bbdf521.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13075559684481680031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cecis-chicken--waffles",
      "poi_latitude": "34.7224925",
      "poi_longitude": "-92.3341452",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-246-5752",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7258-7379-af56-8e6a8e6b1d88",
        "storage_key": "property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxWZIhy-l0ocRnwLzeEG4dbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_34c2d524-daa8-48f3-b3f4-77947448a68d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Sharks fair park",
      "poi_type": "Restaurants",
      "poi_address": "3323 Fair Park Blvd, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-9ff7-70ae-b171-28413d20b417.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-9ff7-70ae-b171-28413d20b417",
        "storage_key": "property/6737460151192628/019e1df1-9ff7-70ae-b171-28413d20b417.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11832341989013648999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharks-fair-park",
      "poi_latitude": "34.68865830000001",
      "poi_longitude": "-92.3480852",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-246-5131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7258-7379-af56-8e6a8e6b1d88",
        "storage_key": "property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNUz4Yr-l0ocRZ_YYPFnsNKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3dc20f5a-92e0-4b12-9a42-be6d55ff3b10",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Riviera Maya",
      "poi_type": "Restaurants",
      "poi_address": "801 Fair Park Blvd, Little Rock, AR 72204, USA",
      "poi_short_description": "Burritos, enchiladas, and other Mexican standards served in casual surroundings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-9ce5-779d-96bb-464cd723f7c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-9ce5-779d-96bb-464cd723f7c1",
        "storage_key": "property/6737460151192628/019e1df1-9ce5-779d-96bb-464cd723f7c1.webp",
        "width": 1280,
        "height": 656
      },
      "poi_business_url": "https://rivieramayarestaurantar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16312490421205000283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riviera-maya",
      "poi_latitude": "34.7442609",
      "poi_longitude": "-92.3339013",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-503-5580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7258-7379-af56-8e6a8e6b1d88",
        "storage_key": "property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRYUs9ISk0ocRW-DiXZybYeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_e68b7bf1-25ad-423f-84f7-43fbf601971e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Ali Baba Mediterranean Restaurant & Market",
      "poi_type": "Restaurants",
      "poi_address": "Town and Country Shopping Center, 3400 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Casual eatery offering a menu of Mediterranean staples, such as falafel and gyros, plus a side market.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-9cb3-743e-bac9-7227141f75dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-9cb3-743e-bac9-7227141f75dd",
        "storage_key": "property/6737460151192628/019e1df1-9cb3-743e-bac9-7227141f75dd.webp",
        "width": 1206,
        "height": 790
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9458143746168245513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ali-baba-mediterranean-restaurant--market",
      "poi_latitude": "34.7213866",
      "poi_longitude": "-92.3425494",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-813-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7258-7379-af56-8e6a8e6b1d88",
        "storage_key": "property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOeLmh1ik0ocRCc3wMKATQoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_f4646808-794a-4344-bd96-9d490a96dad6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "The Mighty Crab",
      "poi_type": "Restaurants",
      "poi_address": "1817 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Casual restaurant specializing in Louisiana-style seafood boils, plus beer, wine, and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-a126-702f-b42d-d29520e089de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-a126-702f-b42d-d29520e089de",
        "storage_key": "property/6737460151192628/019e1df1-a126-702f-b42d-d29520e089de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.themightycrablittlerock.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713726226201178516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-mighty-crab",
      "poi_latitude": "34.736209",
      "poi_longitude": "-92.341367",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-747-1638",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7258-7379-af56-8e6a8e6b1d88",
        "storage_key": "property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb4Hdg1ml0ocRlPG53tVf7Xg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_5cbdaa02-5949-4545-a792-b4c64ba920a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Doughboy Donuts",
      "poi_type": "Restaurants",
      "poi_address": "2900 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Casual spot for familiar donuts and kolaches, plus tacos and breakfast biscuits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-a00a-773e-8adf-f0bd7d749a32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-a00a-773e-8adf-f0bd7d749a32",
        "storage_key": "property/6737460151192628/019e1df1-a00a-773e-8adf-f0bd7d749a32.webp",
        "width": 645,
        "height": 403
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8780664075893689249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doughboy-donuts",
      "poi_latitude": "34.7262048",
      "poi_longitude": "-92.3425613",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-812-3928",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7258-7379-af56-8e6a8e6b1d88",
        "storage_key": "property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJySYtV_il0ocRoUutf3Qv23k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_0fbcc50d-f547-4449-95da-02a52ce6cdde",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Aisha's Fish & Chicken",
      "poi_type": "Restaurants",
      "poi_address": "3820 W 6th Ave, Pine Bluff, AR 71603, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-9da0-75ee-8b83-3e8c20b99645.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-9da0-75ee-8b83-3e8c20b99645",
        "storage_key": "property/6737460151192628/019e1df1-9da0-75ee-8b83-3e8c20b99645.webp",
        "width": 1170,
        "height": 1143
      },
      "poi_business_url": "http://aishas.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8820168683629405276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aishas-fish--chicken",
      "poi_latitude": "34.2234982",
      "poi_longitude": "-92.0431444",
      "poi_miles_from_property": "43.9",
      "poi_walking_minutes": "15 hours 58 mins",
      "poi_biking_minutes": "4 hours 12 mins",
      "poi_driving_minutes": "43 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7258-7379-af56-8e6a8e6b1d88",
        "storage_key": "property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ_5Rx5A8LYYRXGTBvq-IZ3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8e806f94-ea18-4ded-ab12-16b50feffd9a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Lassis Inn",
      "poi_type": "Restaurants",
      "poi_address": "518 E 27th St, Little Rock, AR 72206, USA",
      "poi_short_description": "Neighborhood spot for fried seafood mains, coleslaw and hush puppies, along with a jukebox.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-9cb4-74e1-9c2e-7ee9052aa57e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-9cb4-74e1-9c2e-7ee9052aa57e",
        "storage_key": "property/6737460151192628/019e1df1-9cb4-74e1-9c2e-7ee9052aa57e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/pages/Lassis-Inn/109653119072429",
      "poi_directions_map_url": "https://maps.google.com/?cid=17427264833754375720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lassis-inn",
      "poi_latitude": "34.7227755",
      "poi_longitude": "-92.2684415",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-372-8714",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7258-7379-af56-8e6a8e6b1d88",
        "storage_key": "property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvR_J1w670ocRKCaWXggV2vE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_c123c5aa-6996-4833-ac82-0f5e5303b284",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "The Root Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1500 Main St, Little Rock, AR 72202, USA",
      "poi_short_description": "Chill cafe with a patio offering sandwiches & salads made with locally sourced ingredients.",
      "poi_long_description": "Chill cafe with a patio offering sandwiches & salads made with locally sourced ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-3107-75ae-84ce-4148920ca96f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1def-3107-75ae-84ce-4148920ca96f",
        "storage_key": "property/6737460151192628/019e1def-3107-75ae-84ce-4148920ca96f.webp",
        "width": 1277,
        "height": 473
      },
      "poi_business_url": "http://www.therootcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2097092921480150968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-root-cafe",
      "poi_latitude": "34.7342088",
      "poi_longitude": "-92.2735047",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-414-0423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7258-7379-af56-8e6a8e6b1d88",
        "storage_key": "property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0GAiG270ocRuH_PteZeGh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b1c87f39-e06d-4316-a510-f2c6066fd784",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Lost Forty Brewing",
      "poi_type": "Restaurants",
      "poi_address": "501 Byrd St, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-a215-77b9-877d-4d7e0e1a9981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-a215-77b9-877d-4d7e0e1a9981",
        "storage_key": "property/6737460151192628/019e1df1-a215-77b9-877d-4d7e0e1a9981.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lost40brewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4888545838277880682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lost-forty-brewing",
      "poi_latitude": "34.742613",
      "poi_longitude": "-92.259262",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-319-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4xamJYO70ocRamvEDoqa10M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_fcf64318-22e6-4ea4-959b-1a6a144b00ed",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Certified Pies",
      "poi_type": "Restaurants",
      "poi_address": "9807 W Markham St, Little Rock, AR 72205, USA",
      "poi_short_description": "Casual eatery serving an array of pizzas, plus wings with various sauces.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-ac25-7750-8d48-84f0bcdc72ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-ac25-7750-8d48-84f0bcdc72ab",
        "storage_key": "property/6737460151192628/019e1df1-ac25-7750-8d48-84f0bcdc72ab.webp",
        "width": 1280,
        "height": 1098
      },
      "poi_business_url": "http://www.certifiedpies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16484007798957544925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "certified-pies",
      "poi_latitude": "34.7530167",
      "poi_longitude": "-92.3833595",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-442-5096",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7258-7379-af56-8e6a8e6b1d88",
        "storage_key": "property/6737460151192628/019e1def-7258-7379-af56-8e6a8e6b1d88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZc-vEuh0ocR3RWi08H1wuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_59fa7854-9032-4b97-a190-73b4e982c4e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Circle K | Gas Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "925 Fair Park Blvd, Little Rock, AR 72204, USA",
      "poi_short_description": "Gas station chain featuring convenience stores selling grab-&-go meals, snacks & drinks.",
      "poi_long_description": "Gas station chain featuring convenience stores selling grab-&-go meals, snacks & drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-a5dd-7431-b9ed-3cdfbad31404.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-a5dd-7431-b9ed-3cdfbad31404",
        "storage_key": "property/6737460151192628/019e1df1-a5dd-7431-b9ed-3cdfbad31404.webp",
        "width": 1280,
        "height": 703
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/little-rock/925-fair-park-blvd/2709956?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17884717977556052022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k--gas-station",
      "poi_latitude": "34.74326",
      "poi_longitude": "-92.334103",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-451-7574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-e440-77e9-959f-11507b4446f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df1-e440-77e9-959f-11507b4446f2",
        "storage_key": "property/6737460151192628/019e1df1-e440-77e9-959f-11507b4446f2.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJETtgHXKl0ocRNmhFSD5IM_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_b3d1aab8-2b8d-4b84-b214-d9172d08b613",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Shell",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-ab73-725f-b268-de3f52a4bb1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-ab73-725f-b268-de3f52a4bb1e",
        "storage_key": "property/6737460151192628/019e1df1-ab73-725f-b268-de3f52a4bb1e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://find.shell.com/us/fuel/10006494-1200-s-university-ave/en_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=13178858288249889971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shell",
      "poi_latitude": "34.74107",
      "poi_longitude": "-92.341943",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-663-1022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-e440-77e9-959f-11507b4446f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df1-e440-77e9-959f-11507b4446f2",
        "storage_key": "property/6737460151192628/019e1df1-e440-77e9-959f-11507b4446f2.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJlZxDVn2k0ocRs-RY4Mm15LY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_95f2d9f1-3fbc-4df9-9271-04fb1d23bd7f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Asian Super Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4601 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Grocery store offering a selection of Asian foods, including produce, seafood, and banh mi.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-a78c-7450-a4e6-048fece1476a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-a78c-7450-a4e6-048fece1476a",
        "storage_key": "property/6737460151192628/019e1df1-a78c-7450-a4e6-048fece1476a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=100090790735566",
      "poi_directions_map_url": "https://maps.google.com/?cid=4306928968175230493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asian-super-market",
      "poi_latitude": "34.7103308",
      "poi_longitude": "-92.3429481",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-352-9794",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a3-7405-ab70-5b21590da48c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a3-7405-ab70-5b21590da48c",
        "storage_key": "property/6737460151192628/019e1def-72a3-7405-ab70-5b21590da48c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI9D-bHel0ocRHZ7s1BNJxTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_069ba367-2c35-475a-89e7-2adde08903ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Sam's Oriental Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "3704 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Grocery store for Asian products such as kimbap, spices, snacks, and household goods in Big Town and Country Center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-aa8c-7285-854d-9c0fc57e7122.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-aa8c-7285-854d-9c0fc57e7122",
        "storage_key": "property/6737460151192628/019e1df1-aa8c-7285-854d-9c0fc57e7122.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301965671073022756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-oriental-store",
      "poi_latitude": "34.7191303",
      "poi_longitude": "-92.3426441",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-562-2720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a3-7405-ab70-5b21590da48c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a3-7405-ab70-5b21590da48c",
        "storage_key": "property/6737460151192628/019e1def-72a3-7405-ab70-5b21590da48c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9xYQBVik0ocRJIMPNuGCERI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_73ef5c2c-f915-4efb-bb87-35c1fea8d1f3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Mr. Chen’s Oriental Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "3901 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Sprawling market selling groceries from China and other Asian countries along with produce.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-abc2-71b5-966d-a856417132ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-abc2-71b5-966d-a856417132ad",
        "storage_key": "property/6737460151192628/019e1df1-abc2-71b5-966d-a856417132ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://usmapz.me/mr-chen-s-oriental-supermarket-886849-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=4811636863940915708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mr-chens-oriental-supermarket",
      "poi_latitude": "34.7156583",
      "poi_longitude": "-92.3405667",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-562-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a3-7405-ab70-5b21590da48c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a3-7405-ab70-5b21590da48c",
        "storage_key": "property/6737460151192628/019e1def-72a3-7405-ab70-5b21590da48c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRyV541ek0ocR_HFfDzxexkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_5ca0eb4a-a14e-45eb-88fa-f68eff40244e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "Village Shp Ctr, 3901 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-b235-72fd-93be-2c9863093700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-b235-72fd-93be-2c9863093700",
        "storage_key": "property/6737460151192628/019e1df1-b235-72fd-93be-2c9863093700.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/ar/little-rock/3901-s-university-ave?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5488821317847171120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "34.7153617",
      "poi_longitude": "-92.3405452",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-214-1071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a2-70fc-b1bc-0f4a284e530a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a2-70fc-b1bc-0f4a284e530a",
        "storage_key": "property/6737460151192628/019e1def-72a2-70fc-b1bc-0f4a284e530a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvyR541ek0ocRMEDfVeg1LEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_5509e508-bfa3-43aa-9b47-e86dc59e5659",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "3710 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-b268-7797-aa46-e7e8c4220cd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-b268-7797-aa46-e7e8c4220cd4",
        "storage_key": "property/6737460151192628/019e1df1-b268-7797-aa46-e7e8c4220cd4.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3710+s+university+ave-little+rock-ar-72204/id=5730",
      "poi_directions_map_url": "https://maps.google.com/?cid=9152236149096275221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "34.7183388",
      "poi_longitude": "-92.3428693",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-568-1486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBec5-Fek0ocRFV1fd0lGA38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_55fbb555-ef6c-4fde-a9f9-c042ce9e05eb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Family Medical Center Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "3016 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mygnp.com/pharmacies/family-medical-center-pharmacy-little-rock-ar-72204/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13792857404639766462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-medical-center-pharmacy",
      "poi_latitude": "34.7246809",
      "poi_longitude": "-92.3430125",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-562-3314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-e44d-7115-9543-7cf0d9923b67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df1-e44d-7115-9543-7cf0d9923b67",
        "storage_key": "property/6737460151192628/019e1df1-e44d-7115-9543-7cf0d9923b67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_e25Plak0ocRvmcrWbsSar8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_da083869-9567-4583-a38b-1a8956d432ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Fair Park Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "616 N Harrison St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lrsd.org/o/fair-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5491020125922982759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fair-park-early-childhood-center",
      "poi_latitude": "34.7569759",
      "poi_longitude": "-92.3326944",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-447-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a5-72ab-af5a-dc0794941889",
        "storage_key": "property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7eDOs3yj0ocRZ_soPLYFNEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_43ba41fb-5abf-4722-a497-b4a73c8e91c4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Parkview Arts and Science Magnet High School",
      "poi_type": "Education",
      "poi_address": "2501 John Barrow Rd, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lrsd.org/o/parkview",
      "poi_directions_map_url": "https://maps.google.com/?cid=11018339713254249743&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkview-arts-and-science-magnet-high-school",
      "poi_latitude": "34.7314138",
      "poi_longitude": "-92.3702359",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-447-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a5-72ab-af5a-dc0794941889",
        "storage_key": "property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcZT1OBik0ocRD1UZb5cB6Zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1853415f-704e-4f23-84f2-715e5ca24578",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Henderson Middle School",
      "poi_type": "Education",
      "poi_address": "401 John Barrow Rd, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-b2e5-701b-853e-70676c2d383d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-b2e5-701b-853e-70676c2d383d",
        "storage_key": "property/6737460151192628/019e1df1-b2e5-701b-853e-70676c2d383d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3755498307287911195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henderson-middle-school",
      "poi_latitude": "34.7485686",
      "poi_longitude": "-92.3707367",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-447-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a5-72ab-af5a-dc0794941889",
        "storage_key": "property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh5kSfQik0ocRGwt6INA1HjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_33c1db6e-b60f-4498-b953-5996560bd45d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Western Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "4901 Western Hills Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-b2df-77cb-9002-922906959021.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-b2df-77cb-9002-922906959021",
        "storage_key": "property/6737460151192628/019e1df1-b2df-77cb-9002-922906959021.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lrsd.org/westernhills",
      "poi_directions_map_url": "https://maps.google.com/?cid=9725225107177413693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-hills-elementary-school",
      "poi_latitude": "34.7088671",
      "poi_longitude": "-92.3588288",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-447-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a5-72ab-af5a-dc0794941889",
        "storage_key": "property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEehJFkuk0ocRPRwFYrXw9oY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1f22d8dd-e30b-4010-b23c-0c589120659f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "University of Arkansas at Little Rock",
      "poi_type": "Education",
      "poi_address": "2801 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-35fd-743a-920e-a8902340bc8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1def-35fd-743a-920e-a8902340bc8c",
        "storage_key": "property/6737460151192628/019e1def-35fd-743a-920e-a8902340bc8c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ualr.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13912235513023897276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas-at-little-rock",
      "poi_latitude": "34.7252717",
      "poi_longitude": "-92.3378705",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 501-916-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a5-72ab-af5a-dc0794941889",
        "storage_key": "property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL_aUdFik0ocRvB5dKX0wEsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_01f22828-97fc-439a-bbb8-7e326f8723b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Philander Smith University",
      "poi_type": "Education",
      "poi_address": "900 W Daisy L Gatson Bates Dr, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-b717-719a-b7cb-48075c881748.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-b717-719a-b7cb-48075c881748",
        "storage_key": "property/6737460151192628/019e1df1-b717-719a-b7cb-48075c881748.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.philander.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3443874467063852753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philander-smith-university",
      "poi_latitude": "34.7371492",
      "poi_longitude": "-92.2829693",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-375-9845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a5-72ab-af5a-dc0794941889",
        "storage_key": "property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsSGQbUK70ocR0e5g1JQZyy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_97178eb0-7244-4930-8176-6223406ecb79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Arkansas Baptist College",
      "poi_type": "Education",
      "poi_address": "1600 Doctor M.L.K. Jr Dr, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-ba97-72fe-8eac-8330300183c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-ba97-72fe-8eac-8330300183c7",
        "storage_key": "property/6737460151192628/019e1df1-ba97-72fe-8eac-8330300183c7.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://www.arkansasbaptist.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1068104018682323088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-baptist-college",
      "poi_latitude": "34.7350214",
      "poi_longitude": "-92.2903963",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-420-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a5-72ab-af5a-dc0794941889",
        "storage_key": "property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMYBYYUa70ocRkCC6KPKq0g4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bd18afbd-56c9-4bdc-98a0-8a1160102faf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Arkansas Children's Hospital",
      "poi_type": "Education",
      "poi_address": "1 Children's Way, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-4807-709c-a7e8-dea76c48fa27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1def-4807-709c-a7e8-dea76c48fa27",
        "storage_key": "property/6737460151192628/019e1def-4807-709c-a7e8-dea76c48fa27.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.archildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15800723640570466137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-childrens-hospital",
      "poi_latitude": "34.7430995",
      "poi_longitude": "-92.2918544",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-441-3453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-724b-733e-8df4-e7544ef28ffa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-724b-733e-8df4-e7544ef28ffa",
        "storage_key": "property/6737460151192628/019e1def-724b-733e-8df4-e7544ef28ffa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJf5Fcp1q70ocRWc9Rbm9yR9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6e80c10a-1448-42c1-abba-95cfdf0ff2e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Little Rock Central High School",
      "poi_type": "Education",
      "poi_address": "1500 Little Rock Nine Wy, Little Rock, AR 72202, USA",
      "poi_short_description": "1957 crisis over the desegregation of this school is a significant event in the civil-rights moment.",
      "poi_long_description": "1957 crisis over the desegregation of this school is a significant event in the civil-rights moment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-b989-73da-9b25-ba64b2a805ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-b989-73da-9b25-ba64b2a805ba",
        "storage_key": "property/6737460151192628/019e1df1-b989-73da-9b25-ba64b2a805ba.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "http://lrcentralhigh.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10066891211629443539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-rock-central-high-school",
      "poi_latitude": "34.7367998",
      "poi_longitude": "-92.2986873",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-447-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a5-72ab-af5a-dc0794941889",
        "storage_key": "property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhw9ziUy70ocR07msZTjItIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0c2286d7-170e-4bf0-ad96-b1e102baa1a0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Museum of Discovery",
      "poi_type": "Entertainment",
      "poi_address": "500 President Clinton Ave Ste. 150, Little Rock, AR 72201, USA",
      "poi_short_description": "Playful, interactive exhibits exploring scientific concepts at this family-friendly destination.",
      "poi_long_description": "Playful, interactive exhibits exploring scientific concepts at this family-friendly destination.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-b7d3-764c-ba8d-9df7d18632d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-b7d3-764c-ba8d-9df7d18632d3",
        "storage_key": "property/6737460151192628/019e1df1-b7d3-764c-ba8d-9df7d18632d3.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.museumofdiscovery.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16338434694446452897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-discovery",
      "poi_latitude": "34.7476729",
      "poi_longitude": "-92.2646549",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-396-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-729f-70d2-be69-cfa14e2c82c5",
        "storage_key": "property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUmT0ni70ocRoRBmNMrHveI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6fbf3605-b7b7-45a9-afee-4b90472ff84e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "William J. Clinton Library and Museum",
      "poi_type": "Entertainment",
      "poi_address": "1200 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "3 floors of exhibits & memorabilia related to Clinton's life & presidency, plus a 30-acre park.",
      "poi_long_description": "3 floors of exhibits & memorabilia related to Clinton's life & presidency, plus a 30-acre park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-382d-7278-b46a-af49f158313b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1def-382d-7278-b46a-af49f158313b",
        "storage_key": "property/6737460151192628/019e1def-382d-7278-b46a-af49f158313b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.clintonpresidentialcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8035004359637958132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-j-clinton-library-and-museum",
      "poi_latitude": "34.7464097",
      "poi_longitude": "-92.2583824",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-370-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-729f-70d2-be69-cfa14e2c82c5",
        "storage_key": "property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWsmz4O70ocR9H3v0OQRgm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_c377df71-5cbd-4853-8437-61eac37af5d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Robinson Center",
      "poi_type": "Entertainment",
      "poi_address": "426 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "Renovated 1939 theater features an expansive performance space for musicals, plays & more.",
      "poi_long_description": "Renovated 1939 theater features an expansive performance space for musicals, plays & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-b7e1-703d-ac3b-062d8e144e23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-b7e1-703d-ac3b-062d8e144e23",
        "storage_key": "property/6737460151192628/019e1df1-b7e1-703d-ac3b-062d8e144e23.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.robinsoncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15299738811072087964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robinson-center",
      "poi_latitude": "34.7492294",
      "poi_longitude": "-92.2744598",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-244-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0xGEWO70ocRnIc1HmOXU9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_961159ce-65a0-43b2-81da-96f698ef7790",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Arkansas Museum of Fine Arts",
      "poi_type": "Entertainment",
      "poi_address": "501 E 9th St, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-3b14-7142-ba7c-ecdc24e63d1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1def-3b14-7142-ba7c-ecdc24e63d1a",
        "storage_key": "property/6737460151192628/019e1def-3b14-7142-ba7c-ecdc24e63d1a.webp",
        "width": 1280,
        "height": 686
      },
      "poi_business_url": "https://arkmfa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16794530987996013232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-museum-of-fine-arts",
      "poi_latitude": "34.7380757",
      "poi_longitude": "-92.2660985",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-372-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-729f-70d2-be69-cfa14e2c82c5",
        "storage_key": "property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9p-Prq70ocRsOLKzPMoEuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_f175d924-213a-41c4-8125-f7735db56781",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Historic Arkansas Museum",
      "poi_type": "Entertainment",
      "poi_address": "200 E 3rd St, Little Rock, AR 72201, USA",
      "poi_short_description": "Local art & history museum featuring artifacts, 19th-century structures & historical re-enactments.",
      "poi_long_description": "Local art & history museum featuring artifacts, 19th-century structures & historical re-enactments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-bc2b-71be-8dc1-b09fc0735683.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-bc2b-71be-8dc1-b09fc0735683",
        "storage_key": "property/6737460151192628/019e1df1-bc2b-71be-8dc1-b09fc0735683.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.arkansasheritage.com/historic-arkansas-museum/historic-arkansas-museum-home",
      "poi_directions_map_url": "https://maps.google.com/?cid=15678007188619841545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-arkansas-museum",
      "poi_latitude": "34.7460543",
      "poi_longitude": "-92.2690532",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-324-9351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-729f-70d2-be69-cfa14e2c82c5",
        "storage_key": "property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJk7Fwvnu70ocRCdC073h4k9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e40f55eb-0eb2-44da-842d-947a91e35add",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Old State House Museum",
      "poi_type": "Entertainment",
      "poi_address": "300 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "National Historic Landmark building featuring permanent & traveling exhibits on Arkansas history.",
      "poi_long_description": "National Historic Landmark building featuring permanent & traveling exhibits on Arkansas history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-c20e-7296-baa5-e60a6ceabaa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-c20e-7296-baa5-e60a6ceabaa2",
        "storage_key": "property/6737460151192628/019e1df1-c20e-7296-baa5-e60a6ceabaa2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.oldstatehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4679743598728721160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-state-house-museum",
      "poi_latitude": "34.7490498",
      "poi_longitude": "-92.2725927",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-324-9685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-729f-70d2-be69-cfa14e2c82c5",
        "storage_key": "property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJm453s3y70ocRCDMiOgLK8UA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_98f52579-53a3-4499-9a88-4b22d6608443",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Little Rock Zoo",
      "poi_type": "Entertainment",
      "poi_address": "1 Zoo Dr, Little Rock, AR 72205, USA",
      "poi_short_description": "This 33-acre zoo displays more than 700 animals & has a train, antique carousel & playground.",
      "poi_long_description": "This 33-acre zoo displays more than 700 animals & has a train, antique carousel & playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-3804-754e-8cec-7f8e946d1b38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1def-3804-754e-8cec-7f8e946d1b38",
        "storage_key": "property/6737460151192628/019e1def-3804-754e-8cec-7f8e946d1b38.webp",
        "width": 641,
        "height": 360
      },
      "poi_business_url": "http://www.littlerockzoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8740204647355742622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-rock-zoo",
      "poi_latitude": "34.7468773",
      "poi_longitude": "-92.3302705",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-661-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdcYL5yk0ocRnnnbtdFxS3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_e3e7f068-b74e-4148-92c3-cce29afc519f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Mosaic Templars Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "501 W 9th St, Little Rock, AR 72201, USA",
      "poi_short_description": "Museum with exhibits on African American history, culture & community in Arkansas, plus a gift shop.",
      "poi_long_description": "Museum with exhibits on African American history, culture & community in Arkansas, plus a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-c2cc-74ea-bb46-3d89c7368fc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-c2cc-74ea-bb46-3d89c7368fc9",
        "storage_key": "property/6737460151192628/019e1df1-c2cc-74ea-bb46-3d89c7368fc9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.arkansasheritage.com/mosaic-templars-cultural-center/mtcc-home",
      "poi_directions_map_url": "https://maps.google.com/?cid=7616183010276127830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mosaic-templars-cultural-center",
      "poi_latitude": "34.7408511",
      "poi_longitude": "-92.2770383",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-683-3593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-729f-70d2-be69-cfa14e2c82c5",
        "storage_key": "property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJWQ47Qm-70ocRVrTfdxgesmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_8828c4f4-2c1c-4327-b6d9-cd71dcdf600a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Arkansas Inland Maritime Museum",
      "poi_type": "Entertainment",
      "poi_address": "120 Riverfront Park Dr, North Little Rock, AR 72114, USA",
      "poi_short_description": "Exhibits on naval history & Arkansas aquaculture, plus tours of USS Razorback, a WWII-era submarine.",
      "poi_long_description": "Exhibits on naval history & Arkansas aquaculture, plus tours of USS Razorback, a WWII-era submarine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-bd0b-728f-beff-14da1b86ccf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-bd0b-728f-beff-14da1b86ccf2",
        "storage_key": "property/6737460151192628/019e1df1-bd0b-728f-beff-14da1b86ccf2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/arkansas-inland-maritime-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9401581648013172689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-inland-maritime-museum",
      "poi_latitude": "34.7522251",
      "poi_longitude": "-92.2669543",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-371-8320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-729f-70d2-be69-cfa14e2c82c5",
        "storage_key": "property/6737460151192628/019e1def-729f-70d2-be69-cfa14e2c82c5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJHa_JEH670ocR0R-oeLIgeYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e741c9c2-e40e-42d8-af24-4357ab297e7e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Dickey-Stephens Park",
      "poi_type": "Entertainment",
      "poi_address": "400 W Broadway St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Relaxed ballpark for the Arkansas Travelers minor-league team, also hosting event nights.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-be89-7117-9fc0-3f487d2dc3f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-be89-7117-9fc0-3f487d2dc3f3",
        "storage_key": "property/6737460151192628/019e1df1-be89-7117-9fc0-3f487d2dc3f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milb.com/arkansas",
      "poi_directions_map_url": "https://maps.google.com/?cid=251025925877761128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dickey-stephens-park",
      "poi_latitude": "34.7554878",
      "poi_longitude": "-92.2725898",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-664-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUkZyJy80ocRaIRb5b_SewM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_0bc8c3b7-ccae-4024-a472-55215bd759f3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "OrthoArkansas",
      "poi_type": "Health and Wellness",
      "poi_address": "800 Fair Park Blvd, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-c221-7541-a0a1-f757e379a7d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-c221-7541-a0a1-f757e379a7d6",
        "storage_key": "property/6737460151192628/019e1df1-c221-7541-a0a1-f757e379a7d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://orthoarkansas.com/?utm_source=GMBSocialClimb&utm_medium=OrthoArkansas",
      "poi_directions_map_url": "https://maps.google.com/?cid=15581035619765398652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orthoarkansas",
      "poi_latitude": "34.7442917",
      "poi_longitude": "-92.3357396",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-500-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6QVVq6m0ocRfCzTJFj1Otg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_4d60f739-bdbc-473a-b1f9-04788074db5e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "UAMS Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4301 W Markham St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-4b40-7399-bf9b-64ddd7156385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1def-4b40-7399-bf9b-64ddd7156385",
        "storage_key": "property/6737460151192628/019e1def-4b40-7399-bf9b-64ddd7156385.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://uamshealth.com/location/uams-medical-center/?utm_source=google&utm_medium=gmb&utm_campaign=clinical&utm_term=location&utm_content=profile&utm_specs=uams-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=980427499144927317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uams-medical-center",
      "poi_latitude": "34.7493145",
      "poi_longitude": "-92.3205392",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-686-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-724b-733e-8df4-e7544ef28ffa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-724b-733e-8df4-e7544ef28ffa",
        "storage_key": "property/6737460151192628/019e1def-724b-733e-8df4-e7544ef28ffa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJz5GH8ql0ocRVdiOrp0tmw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_7f052807-fc1e-4316-af71-7793ddbcf011",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1122 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-c326-77c8-8e14-370078ab068c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-c326-77c8-8e14-370078ab068c",
        "storage_key": "property/6737460151192628/019e1df1-c326-77c8-8e14-370078ab068c.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/little-rock-ar-pharmacies/1122-s-university-avenue-little-rock-ar-72204/storeid=10779?WT.mc_id=LS_GOOGLE_RX_10779",
      "poi_directions_map_url": "https://maps.google.com/?cid=12525099826784291867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "34.7420716",
      "poi_longitude": "-92.3421182",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-660-4470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-e44d-7115-9543-7cf0d9923b67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df1-e44d-7115-9543-7cf0d9923b67",
        "storage_key": "property/6737460151192628/019e1df1-e44d-7115-9543-7cf0d9923b67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJibF7i4ek0ocRG8zIf-4X0q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_30b9997f-e8c0-4039-8113-401cf3262d9b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3710 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-c797-760d-b602-9c753a42b36f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-c797-760d-b602-9c753a42b36f",
        "storage_key": "property/6737460151192628/019e1df1-c797-760d-b602-9c753a42b36f.webp",
        "width": 1280,
        "height": 1258
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3710+s+university+ave-little+rock-ar-72204/id=5730",
      "poi_directions_map_url": "https://maps.google.com/?cid=9471439658678270218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "34.7182761",
      "poi_longitude": "-92.3426533",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-568-1486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-e44d-7115-9543-7cf0d9923b67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df1-e44d-7115-9543-7cf0d9923b67",
        "storage_key": "property/6737460151192628/019e1df1-e44d-7115-9543-7cf0d9923b67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97rR9Vek0ocRCrkQDzBQcYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_853da1da-b490-45b3-8b7a-8e7ec0e8c675",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Jack Stephens Event Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Basketball and volleyball events in an arena with courtside and cushioned seats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-c7dd-71a5-8a9e-7d18423386c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-c7dd-71a5-8a9e-7d18423386c3",
        "storage_key": "property/6737460151192628/019e1df1-c7dd-71a5-8a9e-7d18423386c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lrtrojans.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2421330751297371247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-stephens-event-center",
      "poi_latitude": "34.7283999",
      "poi_longitude": "-92.3404773",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-569-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____PvWk0ocRbzzPUn1LmiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_cc42bccf-7fbe-439e-a3e9-2dfbb1b5546f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Jim Dailey Fitness and Aquatic Center",
      "poi_type": "Health and Wellness",
      "poi_address": "300 S Monroe St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-4236-7002-8d2e-e94813486542.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1def-4236-7002-8d2e-e94813486542",
        "storage_key": "property/6737460151192628/019e1def-4236-7002-8d2e-e94813486542.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://littlerock.gov/residents/parks-and-recreation/directory/jim-dailey-fitness-aquatic-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1495873348685574702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jim-dailey-fitness-and-aquatic-center",
      "poi_latitude": "34.7479616",
      "poi_longitude": "-92.3291291",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-664-6976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJodcx3J2k0ocRLrJgmeJowhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8702022b-d26d-4f4d-8961-c0490b270983",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Blue Yoga Nyla",
      "poi_type": "Health and Wellness",
      "poi_address": "3721 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.blueyoganyla.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8960569883019740698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-yoga-nyla",
      "poi_latitude": "34.789767",
      "poi_longitude": "-92.260687",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72a5-72ab-af5a-dc0794941889",
        "storage_key": "property/6737460151192628/019e1def-72a5-72ab-af5a-dc0794941889.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh8JtWQC90ocRGoZ0XtVWWnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_7f928b9c-ade4-4aa6-a12b-bf8764b1d9aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Pulaski County Health Unit - Central Little Rock; Pulaski County Veterans Services",
      "poi_type": "Health and Wellness",
      "poi_address": "3915 W 8th St, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.healthy.arkansas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9483164488633539918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pulaski-county-health-unit---central-little-rock-pulaski-county-veterans-services",
      "poi_latitude": "34.7435293",
      "poi_longitude": "-92.3174",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-280-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7543-70e7-a745-a58bb23d3806.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7543-70e7-a745-a58bb23d3806",
        "storage_key": "property/6737460151192628/019e1def-7543-70e7-a745-a58bb23d3806.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJafBafKSk0ocRTt2Zw9v3moM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_745b0e06-f86f-4a14-80ee-7d474853dbe1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Boyle Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2000 Boyle Park Rd, Little Rock, AR 72204, USA",
      "poi_short_description": "This sizable park features multiple trails & play areas, sports facilities & a fishing stream.",
      "poi_long_description": "This sizable park features multiple trails & play areas, sports facilities & a fishing stream.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-cefe-7308-a8d6-75f4032dc98f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-cefe-7308-a8d6-75f4032dc98f",
        "storage_key": "property/6737460151192628/019e1df1-cefe-7308-a8d6-75f4032dc98f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://littlerock.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6539049716460829786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boyle-park",
      "poi_latitude": "34.7306827",
      "poi_longitude": "-92.3554527",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72b2-77ca-95f5-24d1d4455f15",
        "storage_key": "property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUtajWmk0ocRWjxEXhJfv1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3752ae63-7540-4724-9cb8-718f9d496060",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "War Memorial Park Pavilion",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5101 W Markham St, Little Rock, AR 72205, USA",
      "poi_short_description": "Playground at a large park with a splash pad, fishing and more, plus a duck-filled pond.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-cb69-713a-8c57-77a1b0e8fc39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-cb69-713a-8c57-77a1b0e8fc39",
        "storage_key": "property/6737460151192628/019e1df1-cb69-713a-8c57-77a1b0e8fc39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.littlerock.gov/residents/parks-and-recreation/park-facility-trail-information/war-memorial-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9524645112464390772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "war-memorial-park-pavilion",
      "poi_latitude": "34.7498923",
      "poi_longitude": "-92.3341988",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72b2-77ca-95f5-24d1d4455f15",
        "storage_key": "property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWz5ZfYKk0ocRdLoZHERWLoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b0fa5460-9f8a-4d02-909d-f4ef352c7d35",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Julius Breckling Riverfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Trails & overlooks along the Arkansas River, with playgrounds, historic markers & sculptures.",
      "poi_long_description": "Trails & overlooks along the Arkansas River, with playgrounds, historic markers & sculptures.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-5004-7099-a86a-915d6b1533c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1def-5004-7099-a86a-915d6b1533c9",
        "storage_key": "property/6737460151192628/019e1def-5004-7099-a86a-915d6b1533c9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.littlerock.gov/residents/parks-and-recreation/park-facility-trail-information/riverfront/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13698303629607314796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "julius-breckling-riverfront-park",
      "poi_latitude": "34.7484093",
      "poi_longitude": "-92.266912",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72b2-77ca-95f5-24d1d4455f15",
        "storage_key": "property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ894yxn670ocRbCUwDJMmGr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_88f18d8d-575b-4ef4-bd5b-e7f43034c895",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Big Dam Bridge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4000 Cooks Lndg Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "The longest U.S. pedestrian & bike bridge (4,226 feet), spanning the Arkansas River atop Murray Dam.",
      "poi_long_description": "The longest U.S. pedestrian & bike bridge (4,226 feet), spanning the Arkansas River atop Murray Dam.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-d5aa-779c-97a4-d0e3b6be171e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-d5aa-779c-97a4-d0e3b6be171e",
        "storage_key": "property/6737460151192628/019e1df1-d5aa-779c-97a4-d0e3b6be171e.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17869723390477343867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-dam-bridge",
      "poi_latitude": "34.7925668",
      "poi_longitude": "-92.3584127",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7GbOUyi0ocRexzk674C_vc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bridge"
    },
    {
      "id": "custom_ea5de527-c956-416d-93b8-978fa2f6557e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Two Rivers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "RH6X+QC, 6900 Two Rivers Park Road, Little Rock, AR 72223, USA",
      "poi_short_description": "Natural area with bike paths, picnic tables, a playground, and trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-cc22-712b-9d0b-5c932b04586a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-cc22-712b-9d0b-5c932b04586a",
        "storage_key": "property/6737460151192628/019e1df1-cc22-712b-9d0b-5c932b04586a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://pulaskicounty.net/two-rivers-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3852413415211130700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "two-rivers-park",
      "poi_latitude": "34.8114881",
      "poi_longitude": "-92.4017327",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72b2-77ca-95f5-24d1d4455f15",
        "storage_key": "property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy13IPpah0ocRTN-bFZeFdjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f88b0b0f-1e0b-4d6b-85ea-d6366baa40b7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Rebsamen Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3400 Rebsamen Park Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Public course featuring the scenic Arkansas River, plus a playground and fishing docks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-d400-770f-8861-c418b43fef12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-d400-770f-8861-c418b43fef12",
        "storage_key": "property/6737460151192628/019e1df1-d400-770f-8861-c418b43fef12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.littlerock.gov/residents/parks-and-recreation/city-park-information/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5159628512088809155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rebsamen-park",
      "poi_latitude": "34.7811349",
      "poi_longitude": "-92.316",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72b2-77ca-95f5-24d1d4455f15",
        "storage_key": "property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wCsMTyj0ocRw94HfMuumkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3b70368d-735d-401b-a812-86498dcd55df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Murray Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5900 Rebsamen Park Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Outdoor venue offering a playground, volleyball court, and picnic and barbecue areas, plus boat ramps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-4df3-76f1-a641-c47a0643fe7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1def-4df3-76f1-a641-c47a0643fe7f",
        "storage_key": "property/6737460151192628/019e1def-4df3-76f1-a641-c47a0643fe7f.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "https://www.littlerock.gov/56622",
      "poi_directions_map_url": "https://maps.google.com/?cid=13425768046898910529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "murray-park",
      "poi_latitude": "34.7856017",
      "poi_longitude": "-92.3351056",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72b2-77ca-95f5-24d1d4455f15",
        "storage_key": "property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6TWwWA-j0ocRQRUz6OfoUbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c12da960-a798-4bad-853b-f6279f269732",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "MacArthur Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 E 9th St, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-cee7-72cd-a565-2e010cb822bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-cee7-72cd-a565-2e010cb822bf",
        "storage_key": "property/6737460151192628/019e1df1-cee7-72cd-a565-2e010cb822bf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.littlerock.gov/56621",
      "poi_directions_map_url": "https://maps.google.com/?cid=1556842108685982489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macarthur-park",
      "poi_latitude": "34.7394555",
      "poi_longitude": "-92.2652908",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-72b2-77ca-95f5-24d1d4455f15",
        "storage_key": "property/6737460151192628/019e1def-72b2-77ca-95f5-24d1d4455f15.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwa4JqPe70ocRGRuZO6YDmxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_168b939d-7935-4103-ba8b-136966a77785",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "River Cities Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 E Capitol Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-d030-75bd-9454-f6afadad54dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-d030-75bd-9454-f6afadad54dd",
        "storage_key": "property/6737460151192628/019e1df1-d030-75bd-9454-f6afadad54dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rrmetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3809342745980765106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-cities-travel-center",
      "poi_latitude": "34.7442945",
      "poi_longitude": "-92.2680391",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuazOJHq70ocRsgPlcQuB3TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_d77f7d65-f854-4aa6-a289-badba3adda6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1400 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-580c-757c-bf1c-906067e842ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1def-580c-757c-bf1c-906067e842ad",
        "storage_key": "property/6737460151192628/019e1def-580c-757c-bf1c-906067e842ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=LRK",
      "poi_directions_map_url": "https://maps.google.com/?cid=16485565726769375602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-station",
      "poi_latitude": "34.750483",
      "poi_longitude": "-92.28700990000002",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7513-779b-964b-cc22fd14e23d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7513-779b-964b-cc22fd14e23d",
        "storage_key": "property/6737460151192628/019e1def-7513-779b-964b-cc22fd14e23d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55EYqF-70ocRcmlxKa9-yOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_5f85b344-0b8a-4acb-9fb9-89171d9b8ec5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Bill and Hillary Clinton National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Airport Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_long_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-d070-71fb-bfdb-6caaaead5fa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-d070-71fb-bfdb-6caaaead5fa5",
        "storage_key": "property/6737460151192628/019e1df1-d070-71fb-bfdb-6caaaead5fa5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.clintonairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7788752853462898252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-and-hillary-clinton-national-airport",
      "poi_latitude": "34.7315031",
      "poi_longitude": "-92.2233332",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-372-3439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-e449-76c8-81ed-7fb2f118937f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1df1-e449-76c8-81ed-7fb2f118937f",
        "storage_key": "property/6737460151192628/019e1df1-e449-76c8-81ed-7fb2f118937f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1eIlS2C50ocRTFb3IXQ1F2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_132403f8-002f-4e28-bf22-3b31e73c0cca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Rock Region METRO",
      "poi_type": "Transportation & Transit",
      "poi_address": "901 Maple St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-d4c2-7434-9189-d5d14e800da8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-d4c2-7434-9189-d5d14e800da8",
        "storage_key": "property/6737460151192628/019e1df1-d4c2-7434-9189-d5d14e800da8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://rrmetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8174036123689371751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-region-metro",
      "poi_latitude": "34.7624459",
      "poi_longitude": "-92.2689822",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-375-6717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtavgzIW80ocRZ0i37YsCcHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_fd801661-b587-47f1-b6c8-384235cf72f9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "2nd & Rock Sts",
      "poi_type": "Transportation & Transit",
      "poi_address": "Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-da7d-762e-b570-2ba14316333f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-da7d-762e-b570-2ba14316333f",
        "storage_key": "property/6737460151192628/019e1df1-da7d-762e-b570-2ba14316333f.webp",
        "width": 1280,
        "height": 784
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17253915636101297929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "2nd--rock-sts",
      "poi_latitude": "34.746674",
      "poi_longitude": "-92.267096",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW1wzRHm70ocRCTdgGts4cu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_7b3b16e9-ab20-4ce9-8e9f-ac33053acf1e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Baptist Health Medical Center-Little Rock",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9601 Baptist Health Dr, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-daf8-77af-b094-0c0d4dd1c6f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-daf8-77af-b094-0c0d4dd1c6f8",
        "storage_key": "property/6737460151192628/019e1df1-daf8-77af-b094-0c0d4dd1c6f8.webp",
        "width": 1280,
        "height": 480
      },
      "poi_business_url": "https://www.baptist-health.org/find-care/location/Baptist-Health-Medical-Center-Little-Rock",
      "poi_directions_map_url": "https://maps.google.com/?cid=11761299314245094965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-medical-center-little-rock",
      "poi_latitude": "34.7441024",
      "poi_longitude": "-92.3811957",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-202-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-724b-733e-8df4-e7544ef28ffa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-724b-733e-8df4-e7544ef28ffa",
        "storage_key": "property/6737460151192628/019e1def-724b-733e-8df4-e7544ef28ffa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_wGQvGm0ocRNc6fimmHOKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_72598056-ea2e-4dd3-8a8b-5b642b6c7f09",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "John L. McClellan Memorial Veterans Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4300 W 7th St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-de17-778f-b06f-b59038ac0719.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-de17-778f-b06f-b59038ac0719",
        "storage_key": "property/6737460151192628/019e1df1-de17-778f-b06f-b59038ac0719.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.littlerock.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10390625296849428833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-l-mcclellan-memorial-veterans-hospital",
      "poi_latitude": "34.746427",
      "poi_longitude": "-92.3204701",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-257-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7543-70e7-a745-a58bb23d3806.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7543-70e7-a745-a58bb23d3806",
        "storage_key": "property/6737460151192628/019e1def-7543-70e7-a745-a58bb23d3806.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVJqKk0ocRYeHl1KfqMpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0478a8fc-0000-4b37-87c4-09b7e8e83f40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "CHI St. Vincent Infirmary",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2 St Vincent Cir, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-dd55-72a8-9c7f-69975b4f2f65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-dd55-72a8-9c7f-69975b4f2f65",
        "storage_key": "property/6737460151192628/019e1df1-dd55-72a8-9c7f-69975b4f2f65.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.chistvincent.com/hospitals-locations/chi-st-vincent-infirmary",
      "poi_directions_map_url": "https://maps.google.com/?cid=5554705797602066883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chi-st-vincent-infirmary",
      "poi_latitude": "34.7502877",
      "poi_longitude": "-92.3393435",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-552-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-724b-733e-8df4-e7544ef28ffa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-724b-733e-8df4-e7544ef28ffa",
        "storage_key": "property/6737460151192628/019e1def-724b-733e-8df4-e7544ef28ffa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJwaXYv4Gk0ocRw8HfKX5HFk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d8fd2cad-75c2-4c26-8a3f-4e47e2f3b024",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Dillard's Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Cantrell Rd, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-5437-71ca-b640-86b971ab9201.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1def-5437-71ca-b640-86b971ab9201",
        "storage_key": "property/6737460151192628/019e1def-5437-71ca-b640-86b971ab9201.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dillards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11049574453805387583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dillards-corporate-office",
      "poi_latitude": "34.75433659999999",
      "poi_longitude": "-92.2878465",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-376-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ96xpTae80ocRPw9NLmz5V5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5703a558-90c7-450b-b90a-aa901b30eaa7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Kinetic Fiber Internet Service Provider Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4005 N Rodney Parham Rd, Little Rock, AR 72212, USA",
      "poi_short_description": "Communications company specializing in fiber-based broadband for residential and business customers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-db76-775a-b960-c9062d593788.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-db76-775a-b960-c9062d593788",
        "storage_key": "property/6737460151192628/019e1df1-db76-775a-b960-c9062d593788.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.gokinetic.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp&utm_term=little-rock-ar",
      "poi_directions_map_url": "https://maps.google.com/?cid=6497794853646189753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kinetic-fiber-internet-service-provider-corporate-office",
      "poi_latitude": "34.7871697",
      "poi_longitude": "-92.3975347",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 877-759-9020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxWMOC2ah0ocRuUTxGv7NLFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_90445080-2231-4f1f-993e-f37833ac9bf1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "custom",
      "poi_name": "Heifer International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 World Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1df1-dcfd-728b-aeec-b415c474454e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1df1-dcfd-728b-aeec-b415c474454e",
        "storage_key": "property/6737460151192628/019e1df1-dcfd-728b-aeec-b415c474454e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.heifer.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15947581606820737385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heifer-international",
      "poi_latitude": "34.7447963",
      "poi_longitude": "-92.2561293",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-948-6437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1def-7241-7408-9d78-233e0e25e649",
        "storage_key": "property/6737460151192628/019e1def-7241-7408-9d78-233e0e25e649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6hY55Wj0ocRaXEaPfowUd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    }
  ],
  "office_hours": [
    {
      "id": "custom_9377620f-c1f9-4a4c-9b74-63cf6e14c4a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6b7bc560-6782-4efd-aaa7-7dd9f371c515",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_cd987c07-0d9b-4405-b49f-ca69ebab59ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fcabfa3a-c04a-4654-9970-a79790ae1472",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_70c64f0d-e69e-4eec-9b00-60902c5fc9ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e94cb71c-7957-42fd-852a-d1ee086a22c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_60185b2a-ae97-4a40-a0ae-4fe4bcf9357d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "rating": "5",
      "name": "Joe D",
      "text": "Aiyana provided a very detailed explanation of apartment plans and was very kind and professional during tour.",
      "date": "2026-05-27",
      "title": "false"
    },
    {
      "id": "custom_9ef912ab-fefc-4553-9464-18deb512380f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "rating": "4",
      "name": "Debbie Adams",
      "text": "Yeah just want to say one thing this place is not as bad as what I thought sometimes you can get that way but the landlord is very nice and very understanding and I just want to say that I am sorry for what I have said for the first time she has been trying and we've been working things out and this place is not as bad as what I thought I would recommend this it's not as bad",
      "date": "2026-04-17",
      "title": "false"
    },
    {
      "id": "custom_ef072705-6843-4d72-a087-1a124ca66d1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "rating": "5",
      "name": "Rhodesia Rhodes",
      "text": "I been living here at South Oaks Apartments for about 2 1/2 years. The apartments is kept up very well. The Manager and her staff is very professional. Living here at South Oaks Apartments is for me have been a wonderful experience. If you are looking for a nice and quiet place to live and call home South Oaks Apartments is the place.",
      "date": "2025-12-19",
      "title": "false"
    },
    {
      "id": "custom_e8e40c28-9f1a-4bf1-855a-6d12d2d2edd5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "rating": "5",
      "name": "Katherine Rhodes",
      "text": "Ms Cece she is the Manager and I would recommend her to everyone that I know so if you want a place to live I would come here and talk to her ❤️🧡💛💚💙💜🤎🖤🤍❤️🧡💛💚💙💜🤎🖤🤍❤️🧡💛💚💙💜🤎🖤🤍",
      "date": "2025-12-23",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_7d84b6e7988eb0555b17a5ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019e1def-1924-7796-9f5d-a5c232bd2d51.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1def-1924-7796-9f5d-a5c232bd2d51",
        "storage_key": "property/6737460151192628/019e1def-1924-7796-9f5d-a5c232bd2d51.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6684cd1be5b5fe04c255b77d"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993fdc-e885-7277-a1ab-db790062302b",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-south-oaks-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628"
    },
    {
      "lead_collector_id": "01996473-2028-71cb-a273-6509d78ebdfe",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-south-oaks-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "generator",
      "page_item_url": "apartments-with-pool-little-rock-ar",
      "search_query": "apartments with pool in Little Rock",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Little Rock",
      "h2_subtitle": "Looking for apartments with a pool in Little Rock? South Oaks offers spacious living with great amenities.",
      "page_copy": "Dive into a refreshing lifestyle at South Oaks, where your search for apartments with a pool in Little Rock ends. Tucked away in the friendly Oak Forest neighborhood, this vibrant community presents spacious one- and two-bedroom options tailored for comfort. Enjoy the convenience of our on-site property management, package services, and more while living in a serene environment. \n\nAt South Oaks, we prioritize your leisure and fitness with a well-maintained swimming pool, a fitness center, and a pet play area. Discover the perfect balance between relaxation and activity. Schedule a tour today and explore what makes South Oaks the ideal choice for those seeking a home with a pool in Little Rock.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with blue lounge chairs and a waterfall feature.",
        "public_id": "019d0784-1e80-74ac-820a-ef90c08df461",
        "storage_key": "property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Little Rock, AR",
      "seo_description": "Find top apartments with a pool in Little Rock at South Oaks, offering outstanding amenities in a prime location. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-oak-forest-ar",
      "search_query": "fitness center apartments near Oak Forest",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near Oak Forest",
      "h2_subtitle": "Find apartments with fitness center amenities near Oak Forest. South Oaks offers a blend of comfort and convenience.",
      "page_copy": "Explore the ideal fitness center apartments near Oak Forest at South Oaks in Little Rock. Nestled in a welcoming neighborhood, our community offers one- and two-bedroom layouts that prioritize both style and practicality. These thoughtfully designed living spaces are complemented by premium amenities designed for a healthy and active lifestyle.\n\nAt South Oaks, staying fit has never been easier. Our fully-equipped fitness center provides residents with the convenience of exercise just steps from their front door. Beyond fitness, enjoy the additional benefits of a shimmering pool, pet play area, and walk-up accessibility. Visit today and experience the vibrant community atmosphere that makes South Oaks a standout choice near Oak Forest.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with blue lounge chairs and a waterfall feature.",
        "public_id": "019d0784-1e80-74ac-820a-ef90c08df461",
        "storage_key": "property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near Oak Forest",
      "seo_description": "Discover fitness center apartments near Oak Forest at South Oaks with premier amenities. Tour our community in Little Rock today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-pet-play-area-pulaski-county",
      "search_query": "dog-friendly apartments with pet play area in Pulaski County",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with Pet Play Area",
      "h2_subtitle": "Searching for dog-friendly apartments with a pet play area in Pulaski County? South Oaks is your perfect match.",
      "page_copy": "Welcome to South Oaks, where you'll find exceptional dog-friendly apartments with a pet play area in Pulaski County. Located in the inviting Oak Forest neighborhood of Little Rock, this community is tailor-made for pet lovers seeking a comfortable, convenient lifestyle. Choose from our spacious one- and two-bedroom floor plans, designed with both you and your furry friends in mind.\n\nAt South Oaks, enjoy every minute with your pet thanks to our dedicated pet play area. This feature, along with our premium amenities like a refreshing pool and on-site fitness center, makes our community a fantastic choice for pet owners looking for their next home. Visit us today to see firsthand the vibrant, pet-friendly environment of South Oaks.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with blue lounge chairs and a waterfall feature.",
        "public_id": "019d0784-1e80-74ac-820a-ef90c08df461",
        "storage_key": "property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments with Pet Play Area",
      "seo_description": "Find dog-friendly apartments in Pulaski County with a pet play area at South Oaks. Enjoy top amenities and a great location in Little Rock.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "generator",
      "page_item_url": "gated-community-apartments-72204",
      "search_query": "gated community apartments in zip 72204",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in Zip 72204",
      "h2_subtitle": "Discover the security and comfort of gated community apartments in zip code 72204 at South Oaks.",
      "page_copy": "Experience the peace of mind that comes with living in gated community apartments in zip 72204 at South Oaks. Situated in the heart of Little Rock, our community offers spacious one- and two-bedroom floor plans that cater to those seeking both security and a modern lifestyle. Enjoy well-maintained communal areas and top-notch amenities that add convenience and comfort to everyday living.\n\nApart from the gated access, residents benefit from a range of premium features, including a sparkling swimming pool, fitness center, and dedicated pet play area. With on-site management and package service, you'll find life at South Oaks both secure and stress-free. Explore our community today and find out why South Oaks stands out among the gated community apartments in zip code 72204.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with blue lounge chairs and a waterfall feature.",
        "public_id": "019d0784-1e80-74ac-820a-ef90c08df461",
        "storage_key": "property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments in Zip 72204",
      "seo_description": "Explore gated community apartments in zip 72204 at South Oaks in Little Rock. Find security and comfort with our outstanding amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "generator",
      "page_item_url": "apartments-air-conditioning-little-rock-ar",
      "search_query": "apartments with air conditioning in Little Rock AR",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Little Rock",
      "h2_subtitle": "Looking for apartments with air conditioning in Little Rock, AR? Discover comfort and convenience at South Oaks.",
      "page_copy": "Stay cool and comfortable in the heat of Little Rock, AR by choosing South Oaks, where our apartments feature efficient air conditioning to ensure a pleasant living environment year-round. Located in the charming Oak Forest neighborhood, our community offers spacious one- and two-bedroom layouts designed with modern amenities and convenience in mind.\n\nAt South Oaks, residents enjoy an array of high-end amenities beyond just air conditioning. Dive into our sparkling pool, stay active in our well-equipped fitness center, and let your furry friends roam in our pet play area. Embrace the perfect blend of comfort, style, and convenience that makes South Oaks the ideal choice for those seeking apartments with air conditioning in Little Rock, AR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with blue lounge chairs and a waterfall feature.",
        "public_id": "019d0784-1e80-74ac-820a-ef90c08df461",
        "storage_key": "property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning in Little Rock",
      "seo_description": "Find comfort at South Oaks, offering apartments with air conditioning in Little Rock, AR. Enjoy top amenities and a prime location in Oak Forest.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-oak-forest-little-rock",
      "search_query": "1 bedroom apartments Oak Forest Little Rock",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Oak Forest",
      "h2_subtitle": "Explore stylish 1 bedroom apartments in Oak Forest, Little Rock at South Oaks. Perfect for your lifestyle needs.",
      "page_copy": "Discover the ideal blend of comfort and style with our 1 bedroom apartments in Oak Forest, Little Rock at South Oaks. Nestled in a vibrant yet peaceful neighborhood, our community offers thoughtfully designed floor plans that cater to a wide range of lifestyle preferences. Each apartment features modern interiors and ample space, ensuring you feel right at home.\n\nLiving in South Oaks means access to a variety of amenities that enhance your lifestyle, including a sparkling pool, a state-of-the-art fitness center, and a pet-friendly play area. Whether you're a busy professional or a student, our apartments are conveniently located to suit your needs, providing a welcoming community setting you'll love.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with blue lounge chairs and a waterfall feature.",
        "public_id": "019d0784-1e80-74ac-820a-ef90c08df461",
        "storage_key": "property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Oak Forest, Little Rock",
      "seo_description": "Discover inviting 1 bedroom apartments in Oak Forest, Little Rock at South Oaks. Enjoy modern living with top amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192628",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-pulaski-county",
      "search_query": "2 bedroom apartments Pulaski County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Pulaski County",
      "h2_subtitle": "Looking for spacious 2 bedroom apartments in Pulaski County? Discover South Oaks, where modern living meets comfort.",
      "page_copy": "Discover the perfect blend of space and modern amenities with our 2 bedroom apartments in Pulaski County at South Oaks. Situated in the heart of Little Rock's Oak Forest neighborhood, our community offers versatile floor plans that perfectly accommodate your lifestyle, whether you're a family, couple, or roommates looking to share a spacious home.\n\nEach apartment at South Oaks features contemporary design and comfortable living spaces, complemented by premium amenities like a sparkling pool, a fully-equipped fitness center, and pet-friendly facilities. Our convenient location in Pulaski County ensures easy access to local attractions, shopping, and dining, making South Oaks the ideal choice for anyone seeking a vibrant community experience in 2 bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with blue lounge chairs and a waterfall feature.",
        "public_id": "019d0784-1e80-74ac-820a-ef90c08df461",
        "storage_key": "property/6737460151192628/019d0784-1e80-74ac-820a-ef90c08df461.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Pulaski County",
      "seo_description": "Find spacious 2 bedroom apartments in Pulaski County at South Oaks. Enjoy modern living with excellent amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3407"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483487"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4709040"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NHCKC3ML"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "501-298-4928"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "501-298-4467"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "501-298-4590"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "501-298-4566"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "501-298-4554"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "501-298-4539"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "501-298-4594"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "501-298-4593"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "501-510-8832"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "501-530-9522"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "501-727-2116"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "501-298-4576"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "501-285-8098"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "501-443-8501"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "501-365-9766"
    },
    {
      "ID": "custom_knock_psocl_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=psocl"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "501-298-4630"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "501-764-9108"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_knock_psocl_title",
      "type": "STRING",
      "value": "Paid Social"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321280927"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "501-298-4583"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "501-501-3240"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "c1b4211eeb3f7bae"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "501-842-6070"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_psocl_number",
      "type": "STRING",
      "value": "501-382-1091"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "501-298-4534"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "501-530-9746"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "501-300-8581"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "501-298-4514"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "501-298-4603"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "501-298-4458"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.southoaksapthome.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192628/019e84b3-8f43-774a-953d-e74922b6d31a.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "501-298-4573"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "501-530-9522"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3407",
  "custom_repli_id": "5028483487",
  "custom_realpage_id": "4709040",
  "custom_knock_a_link": "https://www.southoaksapthome.com?utm_knock=a",
  "custom_knock_g_link": "https://www.southoaksapthome.com?utm_knock=g",
  "custom_knock_r_link": "https://www.southoaksapthome.com?utm_knock=r",
  "custom_knock_w_link": "https://www.southoaksapthome.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-NHCKC3ML",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.southoaksapthome.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.southoaksapthome.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.southoaksapthome.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.southoaksapthome.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.southoaksapthome.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.southoaksapthome.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "501-298-4928",
  "custom_knock_ads_link": "https://www.southoaksapthome.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.southoaksapthome.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "501-298-4467",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.southoaksapthome.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.southoaksapthome.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.southoaksapthome.com?utm_knock=ppn",
  "custom_knock_r_number": "501-298-4590",
  "custom_knock_w_number": "501-298-4566",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "501-298-4554",
  "custom_knock_amap_link": "https://www.southoaksapthome.com?utm_knock=amap",
  "custom_knock_ar_number": "501-298-4539",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "501-298-4594",
  "custom_knock_fb_number": "501-298-4593",
  "custom_knock_fl_number": "501-510-8832",
  "custom_knock_gp_number": "501-530-9522",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.southoaksapthome.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "501-727-2116",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.southoaksapthome.com?utm_knock=bcard",
  "custom_knock_bnr_number": "501-298-4576",
  "custom_knock_cfres_link": "https://www.southoaksapthome.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "501-285-8098",
  "custom_knock_lgp_number": "501-443-8501",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.southoaksapthome.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "501-365-9766",
  "custom_knock_psocl_link": "https://www.southoaksapthome.com?utm_knock=psocl",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "501-298-4630",
  "custom_knock_bandit_link": "https://www.southoaksapthome.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.southoaksapthome.com?utm_knock=flyers",
  "custom_knock_osoc_number": "501-764-9108",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_knock_psocl_title": "Paid Social",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321280927",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "501-298-4583",
  "custom_knock_cfres_number": "501-501-3240",
  "custom_knock_chatgpt_link": "https://www.southoaksapthome.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "c1b4211eeb3f7bae",
  "custom_knock_dirmail_link": "https://www.southoaksapthome.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "501-842-6070",
  "custom_knock_propbro_link": "https://www.southoaksapthome.com?utm_knock=propbro",
  "custom_knock_psocl_number": "501-382-1091",
  "custom_knock_bandit_number": "501-298-4534",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "501-530-9746",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.southoaksapthome.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "501-300-8581",
  "custom_knock_dirmail_number": "501-298-4514",
  "custom_knock_propbro_number": "501-298-4603",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "501-298-4458",
  "custom_knock_maintenance_link": "https://www.southoaksapthome.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192628/019e84b3-8f43-774a-953d-e74922b6d31a.mp4",
  "custom_knock_maintenance_number": "501-298-4573",
  "custom_ppc_tracking_phone_number": "501-530-9522",
  "custom_audioeye_site_id": "24f156fe-32ed-42e0-b665-5e3e592259c7",
  "custom_audioeye_site_hash": "36e6f288b80dbf9971ded61f596829fb"
};

export const generatedAt = '2026-11-03T20:41:22.335Z';
